<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Axios from 'axios'
import axios from 'axios'
import _ from 'lodash'

import accounting from 'accounting'
import moment from 'moment'

import AuthByCode from './components/auth/by-code'
import RouterContainer from './components/auth/container'
import SiteHeader from './components/common/site-header'
import SiteSidebar from './components/common/site-sidebar'
import SiteContent from './components/common/site-content'

import { mapGetters } from 'vuex'
import ToastTemplate from './components/utility/toast-template'
import { isMobile } from '@/deviceDetect/index'

Vue.use(Vuelidate)

export default {
  name: 'app',
  components: {
    SiteHeader,
    SiteSidebar,
    SiteContent,
    AuthByCode,
    RouterContainer,
    ToastTemplate,
  },
  computed: {
    ...mapGetters({
      isOverLimit: 'notification/isOverLimit',
      isBusinessTypeBikeRepairer: 'isBusinessTypeBikeRepairer',
    }),
    isLogoutAction () {
      return this.$store.state.isLogout
    },
    isRegisterOrLoginPage () {
      return this.$route.path.includes('/register') || this.$route.path.includes('/auth') || this.$route.path === '/login'
    },
    isHome () {
      return this.$route.path == '/'
    },
    isResetPasswordPage () {
      return this.$route.path.includes('reset-password')
    },
    isAuthByCode () {
      return !!(this.$route && this.$route.params && this.$route.params.authCode && this.$route.params.authCode != '')
    },
    isLoggedIn () {
      return Boolean(this.$store.state.token && this.$store.state.token !== undefined && this.$store.state.token !== 'undefined' && this.$store.state.token.length > 1)
    }
  },
  mounted() {
    setTimeout(() => {
      setInterval(() => {
        this.$store.dispatch('dashboard/loadData', {isShowNProgress: false, timestamp: this.$store.getters['updater/lastTimestamp']}, { root: true })
      }, 15000)
    }, 5000);
    if (this.isMobile) {
      document.body.classList.add('is-mobile');
      console.log('Mobile device detected - uppercase styling applied');
    }
  },
  created: function () {
    if (!this.isHome && !this.isLoggedIn && !this.isResetPasswordPage && !this.isAuthByCode && !this.$route.path.includes('/register') && !this.$route.path.includes('/auth') && !this.$route.path.includes('/registration') && this.$route.path !== '/login' && this.$route.path !== '/select-plan') {
      this.$router.push('/')
    }

    let vm = this
    this.$http.interceptors.response.use(undefined, function (err) {
      // console.log('ERROR:', err, err.response);
      return new Promise(function (resolve, reject) {
        if (err?.response?.status === 401) {
          console.log('this.$store.dispatch("logout")')
          // vm.$store.dispatch('logout')
          // vm.$router.push('/login');
        }
        throw err
      })
    })

    if (this.isLoggedIn  && !this.isAuthByCode) {
      console.log('STARTED!!! isLoggedIn in App')
      this.$store.dispatch('loadMenu')
      this.$store.dispatch('loadUserInfo')
          .then(async () => {
            await this.$store.dispatch('loadVendorInfo')
            this.$store.dispatch('loadDashboardSummary')
            this.$store.dispatch('loadCEStatuses')
            this.$store.dispatch('dashboard/loadNotices')
            this.$store.dispatch('card/loadCards', { page: 1, withTimestamp: false })
            this.$store.dispatch('estimate/loadEstimates', { page: 1, withTimestamp: false })
            this.$store.dispatch('invoice/loadInvoices', { page: 1, withTimestamp: false })
            this.$store.dispatch('dashboard/loadData', {isShowNProgress: true})
            this.$store.dispatch('board/loadInBoard', { page: 1, withTimestamp: false })
            this.$store.dispatch('board/loadDepartureBoard', { page: 1, withTimestamp: false })
          })
          .then(() => {
            if (this.isBusinessTypeBikeRepairer) {
              this.$store.dispatch('loadVehicleMakeModelsBike')
            } else {
              this.$store.dispatch('loadVehicleMakeModels')
            }
            this.$store.dispatch('loadVehicleScheduleNumbers')
            this.$store.dispatch('loadButterfly')
            this.$store.dispatch('loadUsers')
            this.$store.dispatch('loadBusinessTypes')
            this.$store.dispatch('loadCustomerVehicles')
            this.$store.dispatch('loadPartsSearchLocation')
            this.$store.dispatch('report/loadReports')
          })
          .catch(error => console.log(error))
    }
    if (vm.isUpdate) {
      clearInterval(vm.isUpdate)
    }
    if (!vm.isUpdate) {
      this.isUpdate = setInterval(() => {
        this.checkUpdate()
      }, 5000)
    }

    const delay = 60000
    const intervalUpdateIsOverLimit = 3600000
    const intervalUpdateIsOverLimitAfterLoadData = 10000

    setTimeout(() => {
      if (vm.isLoggedIn) {
        vm.$store.dispatch('notification/loadSettings')
        setTimeout(() => {
          if (vm.isOverLimit) {
            toastr.error('Your Data storage limit is close to full. Add-on additional Data pack')
          }
          vm.isOverLimitInterval = setInterval(() => {
            vm.$store.dispatch('notification/loadSettings')
            setTimeout(() => {
              if (vm.isOverLimit) {
                toastr.error('Your Data storage limit is close to full. Add-on additional Data pack')
              }
            }, intervalUpdateIsOverLimitAfterLoadData)
          }, intervalUpdateIsOverLimit)
        }, intervalUpdateIsOverLimitAfterLoadData)
      }
    }, delay)

  },
  data () {
    return {
      isUpdate: false,
      isOverLimitInterval: null,
      isMobile,
    }
  },
  methods: {
    loadBackendNotices (timestamp) {

      if (timestamp <= 0) {
        return
      }

      axios.get(`/fe/notices/${timestamp}`)
          .then(response => {
            if (response.data?._status) {
              // var audio = new Audio('http://soundbible.com/mp3/analog-watch-alarm_daniel-simion.mp3');
              // audio.play();
              for (let i = 0; i < response.data.notices.length; i++) {
                let notice = response.data.notices[i]
                // let type = notice.type;
                // if(['default','primary'].includes(type)){
                //   type = 'info';
                // }
                setTimeout(() => {
                  // toastr[type](notice.text, notice.title, toastrOptions);

                  let options = {
                    toastClassName: 'my-custom-toast-class',
                    timeout: false,
                    closeButton: false
                  }

                  let content = {
                    component: ToastTemplate,
                    props: {
                      toastText: notice.text,
                      toastTitle: notice.title,
                    },
                    listeners: {
                      dismissAll: () => this.$toast.clear()
                    }
                  }
                  this.$toast(content, options)

                }, 100 + 500 * i)
              }
            }
          })
          .catch(e => console.error(e))
    },
    removeInStorageSavedTabs () {
      if (!_.isEmpty(this.$route.params.estimate_id)) {
        this.$storage.remove('views.estimateEdit.' + this.$route.params.estimate_id + '.defaultView')
      } else if (!_.isEmpty(this.$route.params.card_id)) {
        this.$storage.remove('views.cardsEdit.' + this.$route.params.card_id + '.defaultView')
      } else if (!_.isEmpty(this.$route.params.invoice_id)) {
        if (this.$route.path.includes('/excess')) {
          this.$storage.remove('views.invoiceExcess.' + this.$route.params.invoice_id + '.defaultView')
        } else {
          this.$storage.remove('views.invoiceView.' + this.$route.params.invoice_id + '.defaultView')
        }
      }
    },
    checkUpdate () {
      if (this.$store && this.$store.getters.isLoggedIn && this.$store.getters.isCanUpdate) {
        let timestamp = this.$store.getters['updater/lastTimestamp']
        Axios.get('/fe/update/' + timestamp)
            .then(response => {
              if (response?.data && response.data._status) {
                this.$store.dispatch('updater/setLastTimestamp', response.data._timestamp, { root: true })
                if (response.data._update) {
                  if (response.data._update.forceRefreshNeeded) {
                    location.reload()
                  }
                  if (response.data._update.vendor > 0) {
                    this.$store.dispatch('loadVendorInfo')
                  }
                  if ((response.data._update.card > 0 || response.data._update.cardDeleted > 0) && timestamp > 0) {
                    this.$store.dispatch('card/getCardsForTableView', response.data._update.timestamp, { root: true })
                    // this.$store.dispatch('card/loadCards', {page: 1, withTimestamp: true, timestamp: response.data._update.timestamp})
                  }
                  if ((response.data._update.estimate > 0 || response.data._update.estimateDeleted > 0) && timestamp > 0) {
                    this.$store.dispatch('estimate/getEstimatesForTableView', response.data._update.timestamp, { root: true })
                    // this.$store.dispatch('estimateCopy/getEstimatesForTableView', response.data._update.timestamp, {root: true});
                  }
                  if ((response.data._update.invoice > 0) && timestamp > 0) {
                    this.$store.dispatch('invoice/getInvoicesForTableView', response.data._update.timestamp, { root: true })
                  }
                  if (response.data._update.boardIn > 0 || response.data._update.removedBoardIn > 0) {
                    this.$store.dispatch('board/loadInBoard', {
                      page: 1,
                      withTimestamp: true,
                      timestamp: response.data._update.timestamp
                    }, { root: true })
                  }
                  if (response.data._update.boardDeparture > 0 || response.data._update.removedBoardDeparture > 0) {
                    this.$store.dispatch('board/loadDepartureBoard', {
                      page: 1,
                      withTimestamp: true,
                      timestamp: response.data._update.timestamp
                    }, { root: true })
                  }
                  if (response.data._update.activity > 0) {
                    this.$store.dispatch('updater/setActivity', response.data._update.timestamp, { root: true })
                  }
                  if (response.data._update.email > 0) {
                    this.$store.dispatch('updater/setEmail', response.data._update.timestamp, { root: true })
                  }
                  if (response.data._update.files > 0) {
                    this.$store.dispatch('updater/setFiles', response.data._update.timestamp, { root: true })
                  }
                  if (response.data._update.images > 0) {
                    this.$store.dispatch('updater/setImages', response.data._update.timestamp, { root: true })
                  }
                  if (response.data._update.dashboard > 0) {
                    this.$store.dispatch('dashboard/loadData', {isShowNProgress: false, timestamp: response.data._update.timestamp}, { root: true })
                  }
                  if (response.data._update.noticePromo > 0) {
                    this.$store.dispatch('updater/setPromos', response.data._update.timestamp, { root: true })
                  }
                  if (response.data._update.removedNoticePromo > 0) {
                    this.$store.dispatch('updater/setPromos', response.data._update.timestamp, { root: true })
                  }
                  if (response.data._update.noticesCount > 0) {
                    this.loadBackendNotices(response.data._update.timestamp)
                  }
                  if (response.data._update.user > 0) {
                    console.log(response.data._update.timestamp)
                    this.$store.dispatch('loadUsers', response.data._update.timestamp, { root: true })
                  }
                  if (response.data._update.customer > 0) {
                    this.$store.dispatch('loadCustomerVehicles')
                  }

                  if (response.data._update.removedBoardPlanner > 0 || response.data._update.boardPlanner > 0) {
                    this.$store.dispatch('board/loadBookingBoard', { timestamp: response.data._update.timestamp }, { root: true })
                  }
                  if (response.data._update.forceRefreshNeeded) {
                    location.reload()
                  }
                }
              }
            })
            .catch(e => {
              //console.log('UPDATER.Catch!!!', e.response?.status, e.toJSON()?.status, e.request?.status, e.message)
              let code = e?.response?.status || e.toJSON()?.status || e?.request?.status
              if (code === 401) {
                this.$store.dispatch('logout')
                    .then(() => {
                      this.removeInStorageSavedTabs()
                      document.body.style.zoom = null
                      this.$router.push('/').catch(() => {})
                    })
              }

            })
      }
    }
  }
}

Vue.filter('formatMoney', function (value) {
  return accounting.formatMoney(value)
})
Vue.filter('formatDateShort', function (val) {
  return moment(val).format('D-MMM-YY')
})
Vue.filter('formatDate', function (val) {
  return moment(val).format('DD/MM/YYYY')
})
Vue.filter('formatTime', function (val) {
  return moment(val).format('hh:mma')
})
Vue.filter('formatDateTime', function (val) {
  return moment(val).format('DD/MM/YY - hh:mm A')
})
Vue.filter('formatFileSize', function (value) {
  if (!value) value = 0
  if (value < 1024) {
    return value + ' b'
  } else if (value < 1024 ** 2) {
    return (value / 1024).toFixed(1) + ' Kb'
  } else if (value < 1024 ** 3) {
    return (value / (1024 ** 2)).toFixed(1) + ' Mb'
  }
  return (value / (1024 ** 3)).toFixed(1) + ' Gb'
})

</script>

<template>
  <div class="wrapper">
    <AuthByCode v-if="isAuthByCode && !isRegisterOrLoginPage"></AuthByCode>
    <template v-else-if="this.isLoggedIn && !this.isLogoutAction && !isRegisterOrLoginPage">
      <site-sidebar :class="{ 'site-sidebar-mobile': isMobile}"></site-sidebar>
      <site-header></site-header>
      <site-content></site-content>
    </template>
    <RouterContainer v-else-if="!this.isLogoutAction || isRegisterOrLoginPage"></RouterContainer>
  </div>
</template>


<style>
@import url("../node_modules/@syncfusion/ej2-base/styles/material.css");
@import url("../node_modules/@syncfusion/ej2-buttons/styles/material.css");
@import url("../node_modules/@syncfusion/ej2-dropdowns/styles/material.css");
@import url("../node_modules/@syncfusion/ej2-inputs/styles/material.css");
@import url("../node_modules/@syncfusion/ej2-navigations/styles/material.css");
@import url("../node_modules/@syncfusion/ej2-popups/styles/material.css");
@import url("../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css");
@import url("../node_modules/@syncfusion/ej2-lists/styles/material.css");
@import url("../node_modules/@syncfusion/ej2-vue-pdfviewer/styles/material.css");
</style>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap');

#toast-container {
  z-index: 99999999999999;
}

.noselect {
  /*-webkit-touch-callout: none; !* iOS Safari *!*/
  /*-webkit-user-select: none; !* Safari *!*/
  /*-khtml-user-select: none; !* Konqueror HTML *!*/
  /*-moz-user-select: none; !* Old versions of Firefox *!*/
  /*-ms-user-select: none; !* Internet Explorer/Edge *!*/
  /*user-select: none; !* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox *!*/
}

.error-text {
  color: #FF5E5E;
}

.ti-trash {
  color: #FF0000;
}

.clickable {
  cursor: pointer;
}

.display-none {
  display: none !important;
}

.display-block {
  display: block !important;
}

.text-center {
  text-align: center !important;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important
}

.bg-grey {
  background-color: #F5F5F5 !important;
  background-color: rgba(0, 0, 0, 0.025) !important;
}

.bg-navyblue {
  color: #FFFFFF !important;
}

.ma-1-25 {
  margin: 1.25rem !important;
}

.ma-1 {
  margin: 1rem !important;
}

.ma-2 {
  margin: 1rem !important;
}

.mw-4rem {
  min-width: 4rem;
}

.mw-5rem {
  min-width: 5rem;
}

.mw-9rem {
  min-width: 9rem;
}

.max-width-3 {
  max-width: 3rem;
}

.font-12 {
  font-size: 12px !important;
  line-height: 16px !important;
  letter-spacing: normal;
}

.font-13 {
  font-size: 13px !important;
  line-height: 18px !important;
  letter-spacing: normal;
}

.font-14 {
  font-size: 14px !important;
  line-height: 19px !important;
  letter-spacing: 0;
}

.font-16 {
  font-size: 16px !important;
  line-height: 25.88px !important;
  letter-spacing: 0;
}

.font-nunito {
  font-family: 'Nunito Sans', sans-serif !important;
}

.font-bold,
.font-w-700 {
  font-weight: 700 !important;
}

.font-semibold,
.font-w-600 {
  font-weight: 600 !important;
}

.rs-nav .nav-item {
  padding: 0px !important;
  margin: 0px !important;
  text-align: center;
}

.btn.btn-primary a.nav-link {
  color: #FFFFFF;
}

.magic-search-box {
  width: 100% !important;
  position: absolute !important;
  left: 0 !important;
  z-index: 9 !important;
  transition: 0.2s !important;
}

.magic-search-box input {
  width: 100% !important;
  transition: 0.2s !important;
}

.nav .nav-item .nav-link i {
  color: #CCCCCC;
}

.nav .nav-item .nav-link:hover i {
  color: #014C8C;
}

.nav .nav-item .active.nav-link:hover i {
  color: #FFFFFF;
}

/*.col-md-5, .col-md-6, .col-md-7 {
      transition: 0.3s;
    }*/

.tab-special td {
  width: 100%;
  padding: .5rem .25rem;
}

.modal-header.bg-primary .close {
  opacity: 1;
  color: #FFFFFF;
}

@media (min-width: 767px) {
  .modal {
    top: 16% !important;
    left: 16% !important;
  }
}

@media (max-width: 767px) {
  .modal {
    top: 20% !important;
  }
}

#parts-details .btn-group.nav li.btn-primary {
  border: 1px solid #FFFFFF;
  font-weight: bold;
}

#parts-details .tab-special tbody tr {
  background-color: #FFFFFF;
}

#parts-details .tab-special .form-control {
  color: #5E6571;
}

#parts-details .tab-special td span.form-control {
  height: 32px;
}

@media (min-width: 1400px) {
  #estimate-item-list .tab-special .numeric {
    min-width: 3.5rem;
  }

  #estimate-item-list .tab-special .mw-4rem {
    min-width: 6.5rem;
  }
}

@media (max-width: 576px) {
  .rs-stack-items li.nav-item, .rs-stack-items button.btn {
    width: 100%;
    margin: 0 !important;
    text-align: center;
  }

  .rs-stack-items .rs-btn-group {
    margin-left: -.625rem;
    margin-right: -.625rem;
  }

  .rs-stack-items .nav {
    margin-bottom: .625rem;
  }
}

.dropify-wrapper {
  background-color: #F5F5F5 !important;
  background-color: rgba(0, 0, 0, 0.025) !important;
}

.fade-enter-active {
  animation: fade-in .3s;
}

.fade-leave-active {
  animation: fade-in .3s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.5;
  }
}

.slide-enter-active {
  animation: slide-in .3s;
}

.slide-leave-active {
  animation: slide-in .3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

#nprogress .bar {
  z-index: 99999 !important;
}

#nprogress .spinner {
  z-index: 99999 !important;
}

@keyframes fade-in-full {
  0% {
    opacity: 0
  }
  100% {
    opacity: 1
  }
}

.V3 .tabs-component .nav-item .tag {
  border-radius: 50%;
  margin-left: 8px;
  min-width: 20px;
  min-height: 20px;
}

.V3 .tabs-component .tag-info {
  color: #5E79FF;
  background-color: rgba(95, 122, 255, 0.1);
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
  width: 24px;
  height: 20px;
  padding: 0;
}

.tabs-component .inline {
  display: inline-block;
}

.tabs-component::after {
  content: "";
  display: table;
  clear: both;
}

.tabs-component .nav .nav-item .active.nav-link:hover i {
  color: #142742;
}

@media (max-width: 1040px) {
  .tabs-component .nav-item a i {
    display: none;
  }

  footer.footer {
    display: none;
  }

  .estimate-edit .tabs-component .search-parts {
    display: none;
  }

  .V3.fixed-footer .content-area {
    margin-bottom: 0px;
  }
}

@media (max-width: 767px) {
  .V3 .tabs-component .mt-1-sm {
    margin-top: 0px;
  }
}

.site-content:not(.site-content-mobile) .tabs-component .float-sm-left {
  float: left !important;
}

.site-content:not(.site-content-mobile) .tabs-component .float-sm-right {
  float: right !important;
}

.site-content.site-content-mobile .tabs-component .float-sm-left {
  float: none !important;
}

.site-content.site-content-mobile .tabs-component .float-sm-right {
  float: none !important;
}

table.table-bordered td {
  border-left: 0px;
  border-right: 0px;
  border-top: 1px solid rgba(27, 30, 56, 0.25);
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
}

@media (min-width: 766px) {
  .dashboard-avatar-menu .dropdown-menu {
    display: none !important;
  }
}

.dashboard-avatar-menu .dropdown-menu-center {
  left: 50%;
  right: 50%;
  margin-left: -5rem;
}

.dashboard-avatar-menu .dropdown-item {
  line-height: 22px;
}

table.table-bordered td {
  border-left: 0px;
  border-right: 0px;
  border-top: 1px solid rgba(27, 30, 56, 0.25);
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
}

.site-content .v-context {
  background: #FFFFFF !important;
  width: auto !important;
  border-radius: 3px;
  text-align: left;
  width: auto;
  min-width: 140px;

}

.site-content .v-context ul li {
  padding: 8px 25px 5px 10px !important;
  height: 31px;
  border-radius: 3px 3px 0 0;
}

.site-content .v-context ul {
  padding: 0px !important;
  font-family: 'Nunito Sans', sans-serif;
  color: #373A3C;
  font-size: 11px !important;
  line-height: 15px !important;
  font-weight: bold !important;

}

.site-content .v-context ul li:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
  font-weight: bold;
}


.site-content .v-context ul > span {
  right: 35px;
  display: block;
  position: absolute;
  top: 18px;
}

.form-control:disabled, .form-control[readonly] {
  background-color: #FFFFFF !important;
}

.rs-scroll::-webkit-scrollbar {
  width: 7px;
}

.rs-scroll--x::-webkit-scrollbar {
  width: unset;
  height: 7px;
}

.rs-scroll--y::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.rs-scroll::-webkit-scrollbar-thumb {
  background-color: #B7B8C0; /* #5e79ff; */;
}

.additional-card-progress-scroll .__panel::-webkit-scrollbar {
  width: unset;
  height: 7px;
}

/* Firefox */
.rs-scroll {
  scrollbar-width: thin;
  scrollbar-color: #B7B8C0; /* #5e79ff; */
}

html, body {
  scrollbar-width: thin;
  scrollbar-color: #B7B8C0 white; /* #5e79ff; */
}

/* end firefox specific */

.rs-scroll--primary::-webkit-scrollbar-thumb {
  background-color: #5E79FF;
}

.rs-scroll--primary {
  scrollbar-color: #5E79FF;
}

.rs-scroll--transparent {
  scrollbar-color: transparent !important;
}

.rs-scroll--transparent::-webkit-scrollbar-thumb {
  background-color: transparent !important;
}

/* scrollpane */
.rs-scrollpane {
  /* global style here */
  width: 100%;
  overflow: auto;
}

.rs-scrollpane.horizontal-only {
  /* global style here */
}

.jspHorizontalBar {
  background: transparent;
}

.jspDrag {
  background: #B7B8C0 !important;
}

/* scrollpane */

/* vuescroll */
.__bar-wrap-is-horizontal {
  width: calc(100% + 15px);
  /* bottom: -2px; */
}

/* end vuescroll */

/* Vue Timepicker */
/* Selected color to RS Color */
span.vue__time-picker .dropdown ul li:not([disabled]).active {
  background: #5E79FF;
}

span.vue__time-picker input.display-time {
  /* width: auto; */
  height: 32px;
}

span.vue__time-picker.time-picker + .input-group-addon {
  width: 32px;
  position: relative;
  left: -1px;
}

/* End Vue Timepicker */
</style>

<style>
/*
    BTN
     */

.V3 .btn {
  padding: 0.75rem 1rem;
  font-size: 13px;
}

.V3 .btn-outline-primary {
  color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-outline-primary:hover {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-outline-primary:focus,
.V3 .btn-outline-primary.focus {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-outline-primary:active,
.V3 .btn-outline-primary.active,
.V3 .open > .btn-outline-primary.dropdown-toggle {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-outline-primary:active:hover,
.V3 .btn-outline-primary:active:focus,
.V3 .btn-outline-primary:active.focus,
.V3 .btn-outline-primary.active:hover,
.V3 .btn-outline-primary.active:focus,
.V3 .btn-outline-primary.active.focus,
.V3 .open > .btn-outline-primary.dropdown-toggle:hover,
.V3 .open > .btn-outline-primary.dropdown-toggle:focus,
.V3 .open > .btn-outline-primary.dropdown-toggle.focus {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-outline-primary.disabled:focus,
.V3 .btn-outline-primary.disabled.focus,
.V3 .btn-outline-primary:disabled:focus,
.V3 .btn-outline-primary:disabled.focus {
  border-color: #3E70C9;
}

.V3 .btn-outline-primary.disabled:hover,
.V3 .btn-outline-primary:disabled:hover {
  border-color: #3E70C9;
}

.V3 .btn-outline-secondary {
  color: #CCCCCC;
  border-color: #CCCCCC;
}

.V3 .btn-outline-secondary:hover {
  background-color: #CCCCCC;
  border-color: #CCCCCC;
}

.V3 .btn-outline-secondary:focus,
.V3 .btn-outline-secondary.focus {
  background-color: #CCCCCC;
  border-color: #CCCCCC;
}

.V3 .btn-outline-secondary:active,
.V3 .btn-outline-secondary.active,
.V3 .open > .btn-outline-secondary.dropdown-toggle {
  background-color: #CCCCCC;
  border-color: #CCCCCC;
}

.V3 .btn-outline-secondary:active:hover,
.V3 .btn-outline-secondary:active:focus,
.V3 .btn-outline-secondary:active.focus,
.V3 .btn-outline-secondary.active:hover,
.V3 .btn-outline-secondary.active:focus,
.V3 .btn-outline-secondary.active.focus,
.V3 .open > .btn-outline-secondary.dropdown-toggle:hover,
.V3 .open > .btn-outline-secondary.dropdown-toggle:focus,
.V3 .open > .btn-outline-secondary.dropdown-toggle.focus {
  background-color: #CCCCCC;
  border-color: #CCCCCC;
}

.V3 .btn-outline-secondary.disabled:focus,
.V3 .btn-outline-secondary.disabled.focus,
.V3 .btn-outline-secondary:disabled:focus,
.V3 .btn-outline-secondary:disabled.focus {
  border-color: #CCCCCC;
}

.V3 .btn-outline-secondary.disabled:hover,
.V3 .btn-outline-secondary:disabled:hover {
  border-color: #CCCCCC;
}

.V3 .btn-primary {
  color: #fff;
  background-color: #5E79FF;
  border-color: #5E79FF;
  font-weight: bold;
  border-radius: 3px;
  background-color: #5E79FF;
}

.V3 .btn-primary:hover {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-primary:focus,
.V3 .btn-primary.focus {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-primary:active, .V3 .btn-primary.active,
.V3 .open > .btn-primary.dropdown-toggle {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-primary:active:hover, .V3 .btn-primary:active:focus, .V3 .btn-primary:active.focus, .V3 .btn-primary.active:hover, .V3 .btn-primary.active:focus, .V3 .btn-primary.active.focus,
.V3 .open > .btn-primary.dropdown-toggle:hover,
.V3 .open > .btn-primary.dropdown-toggle:focus,
.V3 .open > .btn-primary.dropdown-toggle.focus {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

.V3 .btn-primary.disabled:focus, .V3 .btn-primary.disabled.focus, .V3 .btn-primary:disabled:focus, .V3 .btn-primary:disabled.focus {
  background-color: #467EE1;
  border-color: #467EE1;
}

.V3 .btn-primary.disabled:hover, .V3 .btn-primary:disabled:hover {
  background-color: #467EE1;
  border-color: #467EE1;
}

.V3 .btn-primary.plus-btn-hover,
.V3 .add-supplier.plus-btn-hover,
.V3 .add-customer.plus-btn-hover {
  background-color: #5D54EF;
}

.V3 .btn-primary.plus-btn-hover:hover,
.V3 .add-supplier.plus-btn-hover:hover,
.V3 .add-customer.plus-btn-hover:hover {
  background-color: #5E78FF;
  border-color: #5E78FF;
}

.V3 .btn-secondary {
  color: #1C1F39;
  background-color: #FFFFFF;
  font-weight: bold;
  line-height: 18px;
  box-sizing: border-box;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
}

.V3 .btn-secondary:hover {
  color: #1C1F39;
  background-color: #EEEEEE;
  border-color: #AAAAAA;
}

.V3 .btn-secondary:focus, .V3 .btn-secondary.focus {
  color: #333333;
  background-color: #EEEEEE;
  border-color: #AAAAAA;
}

.V3 .btn-secondary:active, .V3 .btn-secondary.active,
.V3 .open > .btn-secondary.dropdown-toggle {
  color: #333333;
  background-color: #EEEEEE;
  border-color: #BBBBBB;
}

.V3 .btn-secondary:active:hover, .V3 .btn-secondary:active:focus,
.V3 .btn-secondary:active.focus, .V3 .btn-secondary.active:hover, .V3 .btn-secondary.active:focus, .V3 .btn-secondary.active.focus,
.V3 .open > .btn-secondary.dropdown-toggle:hover,
.V3 .open > .btn-secondary.dropdown-toggle:focus,
.V3 .open > .btn-secondary.dropdown-toggle.focus {
  color: #333333;
  background-color: #DDDDDD;
  border-color: #888888;
}

.V3 .btn-secondary.disabled:focus, .V3 .btn-secondary.disabled.focus, .V3 .btn-secondary:disabled:focus, .V3 .btn-secondary:disabled.focus {
  background-color: #FFFFFF;
  border-color: #BBBBBB;
}

.V3 .btn-secondary.disabled:hover, .V3 .btn-secondary:disabled:hover {
  background-color: #FFFFFF;
  border-color: #BBBBBB;
}

</style>

<style>
/*
    Forms
    */
.V3 .customer-service-disabled label.radio > input[type="radio"]:checked:disabled + span.icon i {
  color: white !important;
}

.V3 .customer-service-disabled label.radio > input[type="radio"]:checked + span.icon {
  background-color: #5E79FF !important;
}

.V3 .customer-service-disabled {
  opacity: 1 !important;
}

.V3 .is-read-only {
  opacity: 1 !important;
}

.V3 input.form-control {
  height: 32px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
  box-sizing: border-box;
}


.V3 .form-group {
  margin-bottom: 15px !important;
}

.V3 body.V3 .multiselect__select {
  top: 0px;
  right: -1px;
}

.V3 body.V3 .multiselect__select:before {
  font-size: 23px;
}

.V3 body.V3 .multiselect--active .multiselect__select {
  top: 8px;
}

.V3 select.form-control {
  display: block;
  padding-right: 70px !important;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAArElEQVRIS+2T0Q3CMAxEXzdgk3YEmIgRSjfoRjACbMII6CSQQhrHzkclkOKvNrresy/uwM417OxPB7gJ94h+P6ILsAJPo9UDcAYWa5TaJct8Bu7AqQCR+RWY3gDpN1UDyOAGjAVIav4AjtaU3pqWIOry03nVXEIPIE0O0Zlicc2jgByi95B5CyCF6NnMPL/lSETpN4pLZa1t0xa5f2lE0DpBxPNL0wFuZP8f0Qs+eB0Z+AOfuQAAAABJRU5ErkJggg==") right center no-repeat;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* body select.select_box option */
.V3 select.form-control option {
  padding: 4px;
  line-height: 1.5;
}

/* for IE and Edge */
.V3 select.form-control::-ms-expand {
  display: none;
}

.V3 select.form-control:disabled::-ms-expand {
  background: #FF6600;
}

/* Radio */
.V3 label.radio input[type="radio"] {
  -webkit-appearance: none;
  appearance: none;
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.V3 label.radio {
  position: relative;
  height: 25px;
  width: 105px;
  padding-left: 0px;
  margin-left: 0px;
}

.V3 label.radio.insurance-repair-other {
  width: 87px;
}

.V3 label.radio > span.text {
  display: block;
  margin-top: 5px;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;

}

.V3 label.radio > span.icon {
  display: inline-block;
  box-sizing: border-box;
  height: 25px;
  width: 25px;
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background-color: rgba(27, 30, 56, 0.03);
  float: left;
  margin-right: 10px;
}

.V3 label.radio > .form-check-input:not([disabled="disabled"]) + span.icon:hover {
  border-color: #5E79FF;
  outline: 1px solid #5E79FF !important;
}

.V3 label.radio span.icon i.bx {
  font-size: 22px;
}

.V3 label.radio > input[type="radio"] + span.icon i {
  display: none;
}

.V3 label.radio > input[type="radio"]:checked + span.icon {
  background-color: #5E79FF;
}

.V3 label.radio > input[type="radio"]:checked:disabled + span.icon {
  background-color: rgba(27, 30, 56, 0.03);
}

.V3 label.radio > input[type="radio"]:checked + span.icon i {
  display: inline-block;
  color: white;
}

.V3 label.radio > input[type="radio"]:checked:disabled + span.icon i {
  color: #000000;
}

/* Checkbox
     */
.V3 label.checkbox input[type="checkbox"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.V3 label.checkbox {
  position: relative;
  height: 25px;
  padding-left: 0px;
  margin-left: 0px;
}

.V3 label.checkbox > span.text {
  display: block;
  margin-top: 5px;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;

}

.V3 label.checkbox > span.icon {
  display: inline-block;
  box-sizing: border-box;
  height: 25px;
  width: 25px;
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background-color: rgba(27, 30, 56, 0.03);
  float: left;
  margin-right: 10px;
}

.V3 label.checkbox > span.icon:hover {
  border-color: #5E79FF;
  outline: 1px solid #5E79FF !important;
}

.V3 label.checkbox span.icon i.bx {
  font-size: 22px;
}

.V3 label.checkbox > input[type="checkbox"] + span.icon i {
  display: none;
}

.V3 label.checkbox > input[type="checkbox"]:checked + span.icon {
  background-color: #5E79FF;
}

.V3 label.checkbox > input[type="checkbox"]:checked:disabled + span.icon {
  background-color: rgba(27, 30, 56, 0.03);
}

.V3 label.checkbox > input[type="checkbox"]:checked + span.icon i {
  display: inline-block;
  color: white;
}

.V3 label.checkbox > input[type="checkbox"]:checked:disabled + span.icon i {
  color: #000000;
}


.V3 .width25 {
  width: 25%;
}

.V3 .width50 {
  width: 50%;
}

.V3 .o50 {
  opacity: 0.5;
}

.V3 .o25 {
  opacity: 0.25;
}

.V3 .form-control:disabled, .V3.form-control[readonly] {
  opacity: 0.5;
}

</style>
<style>
/*
    Multiselect
     */
.multiselect__spinner {
  position: absolute;
  right: 1px;
  top: 1px;
  width: 48px;
  height: 30px;
  background: #FFFFFF;
  display: block
}

.multiselect__spinner:after, .multiselect__spinner:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border-color: #41B883 transparent transparent;
  border-style: solid;
  border-width: 2px;
  box-shadow: 0 0 0 1px transparent
}

.multiselect__spinner:before {
  animation: a 2.4s cubic-bezier(.41, .26, .2, .62);
  animation-iteration-count: infinite
}

.multiselect__spinner:after {
  animation: a 2.4s cubic-bezier(.51, .09, .21, .8);
  animation-iteration-count: infinite
}

.multiselect__loading-enter-active, .multiselect__loading-leave-active {
  transition: opacity .4s ease-in-out;
  opacity: 1
}

.multiselect__loading-enter, .multiselect__loading-leave-active {
  opacity: 0
}

.multiselect, .multiselect__input, .multiselect__single {
  font-family: inherit;
  -ms-touch-action: manipulation;
  touch-action: manipulation
}

.multiselect {
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100%;
  text-align: left;
  color: #1C1F39; /* #35495E */
}

.multiselect * {
  box-sizing: border-box
}

.multiselect:focus {
  outline: none
}

.multiselect--disabled {
  opacity: .6
}

.multiselect--active {
  z-index: 1
}

.multiselect--active:not(.multiselect--above) .multiselect__current, .multiselect--active:not(.multiselect--above) .multiselect__input, .multiselect--active:not(.multiselect--above) .multiselect__tags {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.multiselect--active .multiselect__select {
  transform: rotate(180deg)
}

.multiselect--above.multiselect--active .multiselect__current, .multiselect--above.multiselect--active .multiselect__input, .multiselect--above.multiselect--active .multiselect__tags {
  border-top-left-radius: 0;
  border-top-right-radius: 0
}

.multiselect__input, .multiselect__single {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: none;
  border-radius: 5px;
  background: #FFFFFF;
  /*padding: 0 0 0 5px;*/
  transition: border .1s ease;
  box-sizing: border-box;
  /*  margin-bottom: 8px;*/
  vertical-align: top
}

.multiselect__input::-webkit-input-placeholder {
  color: #35495E
}

.multiselect__input:-ms-input-placeholder {
  color: #35495E
}

.multiselect__input::placeholder {
  color: #35495E
}

.multiselect__tag ~ .multiselect__input, .multiselect__tag ~ .multiselect__single {
  width: auto
}

.multiselect__input:hover, .multiselect__single:hover {
  border-color: #CFCFCF
}

.multiselect__input:focus, .multiselect__single:focus {
  border-color: #A8A8A8;
  outline: none
}

.multiselect__single {
  /*padding-left: 5px;*/
  /*margin-bottom: 8px*/
}

.multiselect__tags-wrap {
  display: inline
}

.multiselect__tags {
  min-height: 20px;
  display: block;
  padding: .5rem 35px .5rem .75rem;
  border-radius: 5px;
  border: 1px solid rgba(27, 30, 56, .25);
  background: #FFFFFF;
}

.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #FFFFFF;
  line-height: 1;
  background: #41B883;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis
}

.multiselect__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: all .2s ease;
  border-radius: 5px
}

.multiselect__tag-icon:after {
  content: "\D7";
  color: #266D4D;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
  background: #369A6E
}

.multiselect__tag-icon:focus:after, .multiselect__tag-icon:hover:after {
  color: #FFFFFF
}

.multiselect__current {
  min-height: 20px;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid #E8E8E8
}

.multiselect__current, .multiselect__select {
  line-height: 16px;
  box-sizing: border-box;
  display: block;
  margin: 0;
  text-decoration: none;
  cursor: pointer
}

.multiselect__select {
  position: absolute;
  right: 1px;
  width: 40px;
  height: 22px;
  top: 8px;
  padding: 4px 8px;
  text-align: center;
  transition: transform .2s ease;
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

.multiselect__select:before {
  position: relative;
  right: 0;
  margin-top: 4px;
  content: "\f107";
}

.multiselect__placeholder {
  color: #ADADAD;
  display: inline-block;
}

.multiselect--active .multiselect__placeholder {
  display: none
}

.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #FFFFFF;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #E8E8E8;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 5;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  scrollbar-width: thin;
}

.multiselect__content {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 0;
  min-width: 100%;
  vertical-align: top;
}

.multiselect--above .multiselect__content-wrapper {
  bottom: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #E8E8E8
}

.multiselect__content::webkit-scrollbar {
  display: none
}

.multiselect__element {
  display: block
}

.multiselect__option {
  display: block;
  padding: .5rem .75rem;;
  min-height: 20px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}

.multiselect__option:after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 29px;
  padding-right: 12px;
  padding-left: 20px;
}

.multiselect__option--highlight {
  /*background: #41B883;*/
  outline: none;
  /*color: #FFFFFF*/
  background-color: #edeffd !important;
  color: black;
}

.multiselect__option--highlight:after {
  content: attr(data-select);
  /*background: #41B883;*/
  /*color: #FFFFFF*/
  background-color: #F5F5F5 !important;
  color: #5E6571;
}

.multiselect__option--selected {
  background: #F3F3F3;
  color: #35495E;
  font-weight: 700
}

.multiselect__option--selected:after {
  content: attr(data-selected);
  color: silver
}

.multiselect__option--selected.multiselect__option--highlight {
  background-color: #edeffd !important;
  color: black;
  /*  color: #FFFFFF*/
}

.multiselect__option--selected.multiselect__option--highlight:after {
  background: #F3F3F3;
  color: #35495E;
  content: attr(data-deselect);
  height: 29px;
  /* color: #FFFFFF*/
}

.multiselect--disabled {
  /*background: #EDEDED;*/
  background: #FFFFFF;
  pointer-events: none
}

.multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select, .multiselect__option--disabled {
  /*background: #EDEDED;*/
  background: #FFFFFF;
  color: #A6A6A6;
}

.V3 .multiselect--disabled .multiselect__current,
.V3 .multiselect--disabled .multiselect__select,
.V3 .multiselect__option--disabled {
  background: none;
  color: #A6A6A6;
}

.multiselect__option--disabled {
  cursor: text;
  pointer-events: none
}

.multiselect__option--group {
  background: #EDEDED;
  color: #35495E
}

.multiselect__option--group.multiselect__option--highlight {
  background: #35495E;
  color: #FFFFFF
}

.multiselect__option--group.multiselect__option--highlight:after {
  background: #35495E;
}

.multiselect__option--disabled.multiselect__option--highlight {
  background: #DEDEDE
}

.multiselect__option--group-selected.multiselect__option--highlight {
  background: #FF6A6A;
  color: #FFFFFF
}

.multiselect__option--group-selected.multiselect__option--highlight:after {
  background: #FF6A6A;
  content: attr(data-deselect);
  color: #FFFFFF
}

.multiselect-enter-active, .multiselect-leave-active {
  transition: all .15s ease
}

.multiselect-enter, .multiselect-leave-active {
  opacity: 0
}

.multiselect__strong {
  margin-bottom: 8px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top
}

@keyframes a {
  0% {
    transform: rotate(0)
  }
  to {
    transform: rotate(2turn)
  }
}

.multiselect__select {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

.multiselect__select:before {
  content: "\f107";
  border: none;
}

.V3 .multiselect__content-wrapper {
  border: 1px solid rgba(28, 31, 57, 0.25);
  min-width: 100%;
  width: auto;
}

.V3 .multiselect__input, .V3 .multiselect__single, .V3 .multiselect__tags {
  min-height: 17px;
  line-height: 16px;
  font-size: 12px;
}

.V3 .multiselect__input, .V3 .multiselect__single {
  min-width: 100px;
}

.V3 .multiselect__tags {
  min-width: 112px;
}

.V3 .assessors-page .insurer-td, .insurer-td .multiselect {
  width: 200px !important;
}

.select_chips_multi_select.multiselect {
  box-sizing: border-box;
  min-height: auto !important;
  height: 33px;
  cursor: pointer;
}

.select_chips_multi_select .multiselect__tags .multiselect__tags-wrap {
  display: none;
}

.select_chips_multi_select .multiselect__tags {
  min-height: auto;
  display: block;
  padding: 0;
  border-radius: 0;
  border: 0;
  background: transparent;
  font-size: 13px;
}

.select_chips_multi_select .multiselect__placeholder {
  margin-bottom: 0;
  display: none;
}

.select_chips_multi_select .multiselect__single {
  font-size: 13px;
  padding-left: 0;
  margin-bottom: 0;
}

.select_chips_multi_select .multiselect__input {
  font-size: 13px !important;
  margin-bottom: 0 !important;
  width: 100% !important;
  padding: 0 !important;
  position: relative !important;
}

.select_chips_multi_select .multiselect__spinner {
  height: 28px;
}

.select_chips_multi_select .multiselect__content-wrapper {
  left: 0;
}

.select_chips_multi_select .multiselect__option {
  display: block;
  padding: 6px 10px;
  min-height: 20px;
  line-height: 15px;
}

.select_chips_multi_select .multiselect__select:before {
  position: relative;
  margin-top: 4px;
  content: "\f107";
  font-family: FontAwesome;
  top: 3px;
  border-color: transparent;
}

.select_chips_multi_select .multiselect__select {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  padding: 0;
  z-index: 3;
  bottom: 0;
  margin: auto;
}

.select_chips_multi_select .multiselect__option:after {
  top: -5px;
  right: 0;
  position: absolute;
  line-height: normal;
  padding-right: 12px;
  padding-left: 0;
  font-size: 13px;
  bottom: 0;
  margin: auto;
}

/*.select_chips_multi_select span.multiselect__option.multiselect__option--selected:after {*/
/*    content: "\f00c";*/
/*    background: transparent;*/
/*    color: #5d6471;*/
/*    line-height: 20px;*/
/*    font-family: FontAwesome;*/
/*}*/
.select_chips_multi_select .multiselect__option--highlight:after {
  background-color: transparent;
  color: transparent;
  height: 29px;
}

.select_chips_multi_select .multiselect__option--highlight.multiselect__option--selected:after {
  content: "\f00d";
  background: transparent;
  color: #FFFFFF;
  line-height: 20px;
  font-family: FontAwesome;
}

.select_chips_multi_select span.multiselect__option.multiselect__option--selected:after {
  content: "\f2bc";
  background: transparent;
  color: #5D6471;
  line-height: 20px;
  font-family: "Ionicons";
}

.select_chips_multi_select .multiselect__option.multiselect__option--highlight.multiselect__option--selected:after {
  content: "\e646" !important;
  background: transparent;
  line-height: 20px;
  font-family: 'themify' !important;
  font-size: 10px;
}

.select_chips_multi_select .multiselect__option.multiselect__option--selected {
  background: transparent !important;
}

.select_chips_multi_select .multiselect__option.multiselect__option--highlight {
  background-color: #F5F5F5 !important;
  color: #5E6571;
}

.chips__supplied {
  width: 100%;
  min-height: 80px;
  border-radius: 3px;
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, .15);
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}

.chip__wrap i {
  position: relative;
  left: 7px;
  font-size: 10px;
  cursor: pointer;
}

.card-header {
  border-bottom: 1px solid #FFFFFF !important;
}

.V3 .suppliers-edit-page .card-block .action .btn_edit {
  width: 19px;
  height: 19px;
}

.V3 .suppliers-edit-page .card-block table.table.b-table > thead > tr > th {
  font-size: 13px;
  font-weight: bold;
}

.V3 .suppliers-edit-page .card-block table.table.b-table > thead > tr > th {
  color: black !important;
}

.V3 .suppliers-edit-page .card-block table.table.b-table > tbody > tr > td:first-child {
  font-size: 12px;
  font-weight: bold;
}

.V3 .suppliers-edit-page .card-block table.table.b-table > tbody > tr > td {
  font-size: 12px;
  font-weight: 600;
}

.multi_select_context_menu .multiselect__select, .multi_select_context_menu .multiselect__single {
  display: none;
}

.multi_select_context_menu .multiselect__content-wrapper {
  border-radius: 0 !important;
  border: 0px !important;
  position: relative !important;
  display: block !important;
}

.multi_select_context_menu .multiselect__input {
  width: 100% !important;
  position: relative !important;
  padding: 5px !important;
}

.multi_select_context_menu .multiselect__placeholder {
  display: none;
}

.multi_select_context_menu .multiselect__spinner {
  display: none;
}

.multi_select_context_menu .multiselect__option {
  display: block;
  padding: 6px 10px;
  min-height: 20px;
  line-height: 15px;
}

.multi_select_context_menu .multiselect__option--highlight:after {
  background-color: transparent;
  color: transparent;
}

.multi_select_context_menu .multiselect__option:after, .multi_select_context_menu .multiselect__select {
  position: absolute;
  height: 20px;
  top: 0;
  bottom: 0;
  margin: auto;
}

.multi_select_context_menu .multiselect__option.multiselect__option--selected:after {
  content: "\f2bc";
  background: transparent;
  color: #5D6471;
  line-height: 20px;
  font-family: "Ionicons";
}

.multi_select_context_menu .multiselect__option.multiselect__option--highlight.multiselect__option--selected:after {
  content: "\e646" !important;
  background: transparent;
  line-height: 20px;
  font-family: 'themify' !important;
  font-size: 10px;
}

.multi_select_context_menu .multiselect__option.multiselect__option--selected {
  background: transparent !important;
}

.multi_select_context_menu .multiselect__option.multiselect__option--highlight {
  background-color: #F5F5F5 !important;
  color: #5E6571;
}

.multi_select_context_menu .multiselect__tags-wrap {
  display: none;
}

.multi_select_context_menu .multiselect__tags {
  border-bottom: 1px solid;
  padding: 0;
  min-height: 0;
  border-radius: 0;
}

.multi_select_context_menu {
  position: relative !important;
  height: auto !important;
  border: 0px !important;
  padding: 0 !important;
}

.multi_select_context_menu .multiselect__input {
  font-size: 13px;
  margin-bottom: 0;
  width: 100% !important;
  padding: 0;
  position: relative !important;
}

.multiselect-style .multiselect .multiselect__tags {
  font-family: "Nunito Sans";
  font-size: 16px !important;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px !important;
  border-radius: 4px !important;
  height: 43px !important;
  color: #1C1F39;
  padding: 5px 30px 5px 13px;
}

.multiselect-style .multiselect .multiselect__tags .multiselect__placeholder {
  padding-top: 5px;
}

.multiselect-style .multiselect .multiselect__single {
  font-family: "Nunito Sans";
  font-size: 16px !important;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px !important;
  color: #1C1F39;
  padding: 5px 0;
}

.multiselect-style .multiselect .multiselect__option {
  font-family: "Nunito Sans";
  font-size: 16px !important;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px !important;
  color: #1C1F39;
}

.multiselect-style .multiselect .multiselect__input {
  font-size: 16px !important;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px !important;
  padding: 5px 0;
}

.multiselect-style .multiselect .multiselect__select {
  top: 4px !important;
}

.multiselect-style .multiselect--active .multiselect__select {
  top: 12px !important;
}

fieldset[disabled] .multiselect {
  pointer-events: none
}

@keyframes a {
  0% {
    transform: rotate(0)
  }
  to {
    transform: rotate(2turn)
  }
}

.settings-page-users .multiselect__select:before {
  font-size: 23px;
}

.input-trigger .multiselect__single {
  white-space: nowrap;
}

.input-trigger .multiselect__option,
.input-trigger-last .multiselect__option {
  margin-right: 0 !important;
}

/* is Linked */
.qtit.is-linked td:not(first-child) > input,
.qtit.is-linked select,
.qtit.is-linked .multiselect,
.qtit.is-linked div > span,
.qtit.is-linked div > .btn_trush {
  display: none;
}
</style>

<style>
/*
    PageHeader and
    Breadcrumbs
     */
.V3 .page-header {
  min-height: 75px;
  padding: 14px 0 14px 15px;
  margin-bottom: 0;
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
  background-color: #FFFFFF;
  font-size: 18px;
  position: sticky;
  position: -webkit-sticky;
  top: 60px;
  z-index: 1030;
}

.V3 .page-header h4 {
  height: 24px;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  color: #1C1F39;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media (max-width: 425px) {
  .V3 .invoice-excess-page .page-header h4,
  .V3 .invoice-view-page .page-header h4,
  .V3 .estimates-edit-page .page-header h4,
  .V3 .cards-edit-page .page-header h4 {
    height: auto;
  }
}
@media (max-width: 1024px) {
  .V3 .invoice-excess-page .page-header h4,
  .V3 .invoice-view-page .page-header h4,
  .V3 .estimates-edit-page .page-header h4,
  .V3 .cards-edit-page .page-header h4 {
    margin-right: 225px;
  }
}
@media (max-width: 700px) {
  .V3 .invoice-excess-page .page-header h4,
  .V3 .invoice-view-page .page-header h4,
  .V3 .estimates-edit-page .page-header h4,
  .V3 .cards-edit-page .page-header h4 {
    margin-right: 125px;
  }
}

.V3 .page-header .breadcrumbs {
  list-style: none;
  border-radius: 0;
  padding: 0px 0px 15px 0px;
  margin-bottom: 0px !important;
  background-color: white;
}

.V3 .page-header .breadcrumbs .breadcrumb-item {
  height: 18px;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.V3 .page-header .breadcrumbs .breadcrumb-item a:hover {
  color: #5e79ff;
}

.V3 .page-header .breadcrumbs .breadcrumb-item.active {
  color: #5e79ff;
}

@media (max-width: 425px) {
  .V3 .page-header .breadcrumbs li.breadcrumb-item.mobile-path-hide {
    display: none;
  }

  .V3 .page-header h4 .autosave {
    display: block;
    position: absolute;
    right: 15px;
    top: 15px;
  }
}

.V3 .page-header .breadcrumbs .breadcrumb-item + .breadcrumb-item::before {
  content: "//";
  color: #a6a6a6;
  display: inline-block;
  padding-right: 5px;
  padding-left: 5px;
}

.V3 .page-header .breadcrumbs .breadcrumb-item + .breadcrumb-item.active::before {
  content: "//";
  color: #5e79ff;
  display: inline-block;
  padding-right: 5px;
  padding-left: 5px;
}

.V3 .page-header .breadcrumbs .breadcrumb-item a {
  color: #a6a6a6;
  font-weight: 600;
}

@media (min-width: 1024.5px) {
  .V3 .cards-edit-page .page-header .page-header-nav-btn,
  .V3 .estimates-edit-page .page-header .page-header-nav-btn,
  .V3 .cards-edit-page .page-header .page-header-nav-pin-images,
  .V3 .estimates-edit-page .page-header .page-header-nav-pin-images,
  .V3 .cards-edit-page .page-header .page-header-nav-options,
  .V3 .estimates-edit-page .page-header .page-header-nav-options {
    display: none !important;
  }
}

@media (min-width: 768.5px) {
  .V3 .page-header .page-header-nav-btn,
  .V3 .page-header .page-header-nav-pin-images,
  .V3 .page-header .page-header-nav-options {
    display: none;
  }

  .V3 .cards-edit-page .page-header .page-header-nav-btn,
  .V3 .estimates-edit-page .page-header .page-header-nav-btn,
  .V3 .cards-edit-page .page-header .page-header-nav-pin-images,
  .V3 .estimates-edit-page .page-header .page-header-nav-pin-images,
  .V3 .cards-edit-page .page-header .page-header-nav-options,
  .V3 .estimates-edit-page .page-header .page-header-nav-options {
    display: inherit;
  }

  .V3 .estimates-edit-page .page-header .page-header-nav-options,
  .V3 .cards-edit-page .page-header .page-header-nav-options {
    position: absolute;
    right: 15px;
    bottom: 15px;
    z-index: 11111;
  }

  .V3 .estimates-edit-page .page-header .page-header-nav-pin-images,
  .V3 .cards-edit-page .page-header .page-header-nav-pin-images {
    position: absolute;
    right: 115px;
    bottom: 15px;
    z-index: 11111;
  }

  .V3 .estimates-edit-page .page-header .page-header-nav-pin-images label span.text,
  .V3 .cards-edit-page .page-header .page-header-nav-pin-images label span.text {
    width: 110px;
  }
}

.V3 .site-content-mobile .page-header .page-header-nav-btn {
  display: block;
  position: absolute;
  bottom: 15px;
  right: 15px;
}

@media (max-width: 768px) {
  .V3 .page-header .page-header-nav-options {
    position: absolute;
    right: 15px;
    bottom: 15px;
    z-index: 11111;
  }

  .V3 .page-header .page-header-nav-pin-images {
    display: none;
    position: absolute;
    right: 115px;
    bottom: 15px;
    z-index: 11111;
  }

  .V3 .page-header .page-header-nav-pin-images label span.text {
    width: 110px;
  }
}

@media (max-width: 425px) {
  .V3 .page-header .page-header-nav-pin-images {
    display: none;
  }
}

.V3 .site-content-mobile .page-header .page-header-nav-btn,
.V3 .site-content-mobile .page-header .page-header-nav-pin-images,
.V3 .site-content-mobile .page-header .page-header-nav-options {
  display: block !important;
}

</style>

<style>
.V3 .wrapper {
  overflow: visible;
}

.V3 .b-table {
  background: white;
}

.V3 .row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.V3 .table td {
  vertical-align: middle;
  border-bottom: 1px solid rgba(27, 30, 56, .25);
}

.V3 .col-md-12 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.V3 .table.table-bordered td {
  vertical-align: middle;
}

.V3 input.form-control.search-input {
  background: url('data:image/svg+xml;base64,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') no-repeat center right;
  background-position: right 7px center;
  height: 38px;
}

.V3 .content-area {
  padding-top: 0px;
}

.V3 h4.modal-title {
  display: block;
  padding-left: 0px;
  padding-top: 0px;
  margin: 0;
  line-height: 1.5;
  font-weight: 600;
  background: none;
  font-size: 1.5rem;
  color: inherit;
  position: relative;
  top: 0px;
}

.V3 .container-fluid {
  padding-left: 0px;
  padding-right: 0px;
}

.V3 .box-block {
  padding: 0px;
}

.V3 .tabs-component {
  padding-top: 10px;
  /*    height: 60px; */
  border-bottom: none;
  position: sticky;
  position: -webkit-sticky;
  top: 135px;
  z-index: 1000;
  background: #FFFFFF;
}

.V3 .tabs-component::after {
  content: '';
  width: 100%;
  height: 10px;
  display: block;
  background: #e3e4e7;
}

.V3 .tabs-component.tabs-component-2 {
  position: sticky;
  position: -webkit-sticky;
  top: 204px;
  z-index: 999;
}

.V3 .tabs-component.tabs-component-2::after {
  height: 1px;
}

.V3 .tabs-component ul {
  border-bottom: none;
}

.V3 .tabs-component ul li {
  border-bottom: 1px solid white;
}

.V3 .tabs-component ul li:hover {
  border-bottom: 1px solid #DCDCDC;
}

.V3 .nav-tabs .nav-link:focus,
.V3 .nav-tabs .nav-link:hover {
  border: none;
}

@media (max-width: 425px) {
  .V3 .tabs-component ul.nav-tabs-2 {
    position: relative;
  }

  .V3 .tabs-component ul li.mobile-hide {
    display: none;
  }

  .V3 .tabs-component ul li.mobile-pin-images {
    display: none;
    position: absolute;
    bottom: 15px;
    right: 15px;
    width: 100px;
    border: none;
  }

  .V3 .tabs-component ul li.mobile-pin-images label span.text {
    width: 150px;
  }
}

@media (max-width: 1024px) {
  .V3 .tabs-component .tab-header .tabs-nav-right-pin-images {
    display: none !important;
  }
}

@media (min-width: 425.5px) {
  .V3 .tabs-component ul li.mobile-pin-images {
    display: none;
  }
}

.V3 .tab-content {
  padding-left: 15px;
}

.V3 .ex-cards-edit .tab-content {
  margin-top: 0;
}

.V3 .tab-content-table {
  margin-top: 0px;
  /*    margin-top: 10px; */
  /*   padding-left: 15px; */
}

.V3 .tab-content-table,
.V3 .tab-content.tab-content-table {
  /*   margin-top: 8px; */
  padding-left: 0px;
  border-top: 1px solid rgba(27, 30, 56, 0.25);
}

.tab-content > .tab-pane,
.tab-content-table > .tab-pane {
  display: none;
}

.tab-content > .active,
.tab-content-table > .active {
  display: block;
}

.V3 .wizard .wizard__body table.b-table thead th,
.V3 .tab-content #card-notes-table th,
.V3 .tab-content #card-files-table th,
.V3 .tab-content-table table thead th {
  height: 48px;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
}

.V3 .wizard .wizard__body table.b-table thead th,
.V3 .tab-content #card-notes-table th,
.V3 .tab-content #card-files-table th,
.V3 .tab-content-table table thead th,
.V3 .tab-content-table table tr td {
  padding: 13px 15px;
}

.V3 .tab-content-table table.table thead th {
  border-top: 1px solid rgba(27, 30, 56, 0.12);
  vertical-align: middle;
}

.new-note-btn {
  position: fixed;
  top: 146px;
  right: 0;
  z-index: 1000;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.nav-title {
  padding: 15px 15px 0 15px;
}

@media screen and (max-width: 767px) {
  .nav-title {
    padding: 15px 10px 0 15px;
  }
}

.V3 .notes-table #card-notes-table tbody tr td {
  vertical-align: top;
}

.V3 .notes-table #card-notes-table tbody tr {
  margin: 0 15px;
  border-bottom: 1px solid rgba(27, 30, 56, 0.1);
}

.V3 .notes-table #card-notes-table tbody {
  position: relative;
}

.V3 .notes-table .ti-plus {
  margin-right: 5px;
  font-weight: bold
}

.V3 .notes-table .bx-pencil {
  font-size: 19px;
  color: black;
}

.V3 .notes-table .notes-table {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.V3 .notes-table #card-notes-table tr td {
  padding: 16px 15px 14.5px 15px;
}

.V3 .notes-table .note-action a {
  color: #1B1E38;
}

.V3 .notes-table .note-action > a {
  font-size: 19px;
}

.V3 .notes-table .card-note {
  min-width: 200px;
  overflow-wrap: break-word;
  font-size: 12px;
  font-weight: 600;
}

.V3 .notes-table .created-by {
  min-width: 100px;
  font-size: 12px;
  font-weight: bold;
}

.V3 .notes-table .created-on {
  min-width: 110px;
  font-size: 12px;
  font-weight: 600;
}

.V3 .notes-table .action {
  max-width: 100px;
  width: 100px;
}

.V3 .nav-tabs.nav-tabs-2,
.V3 .tabs-component .tab-header {
  /* height: 50px;*/
  padding-left: 15px;
  padding-right: 15px;
}

.V3 .tabs-component .tab-header.view-header-buttons {
  padding-left: 0px;
  display: inline-block;
}

.V3 .tabs-component .tab-header.view-header-buttons .cards-view-button {
  box-sizing: border-box;
  height: 40px;
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background: white;
}

.V3 .tabs-component .tab-header.view-header-buttons .cards-view-button > button {
  padding-left: 20px;
  padding-right: 20px;
  background: white;
}

.V3 .tabs-component .tab-header.view-header-buttons .cards-view-button > button.active {
  border-radius: 3px;
  transition: none;
  background: linear-gradient(135deg, rgb(114, 103, 231) 0%, rgb(98, 89, 239) 49.12%, rgb(78, 69, 238) 100%);
}

.V3 .tabs-component .tab-header.view-header-buttons .cards-view-button > button.active:hover {
  background: #5E78FF !important;
}

@media (min-width: 426px) {
  .V3 .tabs-component .tab-header.float-sm-right > div {
    display: inline-block;
    margin: 0px;
  }

  .V3 .tabs-component .tab-header.float-sm-right div.tabs-nav-right-search {
    min-width: 350px;
  }
}

@media (max-width: 425px) {
  .V3 .tabs-component .tab-header.float-sm-left,
  .V3 .tabs-component .tab-header.float-sm-right > div {
    margin-bottom: 10px !important;
    display: block;
    text-align: left;
    margin-right: 30px;
  }

  .V3 .tabs-component .tab-header.float-sm-right {
    margin-top: 10px;
  }
}

@media (max-width: 1024px) {
  .V3 .estimates-edit-page .tabs-component .tab-header.float-sm-right div.tabs-nav-right-btn,
  .V3 .cards-edit-page .tabs-component .tab-header.float-sm-right div.tabs-nav-right-btn,
  .V3 .estimates-edit-page .tabs-component .tab-header.float-sm-right div.tabs-nav-right-options,
  .V3 .cards-edit-page .tabs-component .tab-header.float-sm-right div.tabs-nav-right-options {
    display: none !important;
  }
}


.V3 .site-content-mobile .tabs-component .tab-header.float-sm-right div.tabs-nav-right-btn,
.V3 .site-content-mobile .tabs-component .tab-header.float-sm-right div.tabs-nav-right-options {
  display: none !important;
}

.V3 .site-content-mobile .tabs-component .tab-header.float-sm-right div.tabs-nav-right-search {
  width: 100%;
  margin-right: 0px;
}

.V3 .tab-header label.form-check-inline.checkbox > span.text {
  width: 120px;
}

.V3 .nav-tabs-2 .nav-link {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0);
}

.V3 .nav-tabs-2 .nav-link:not(.active):hover {
  position: relative;
  text-shadow: 0 0 1px black;
}

.V3 .nav-tabs-2 .nav-link.active {
  position: relative;
  border: none;
  color: black;
  font-weight: 800;
}

.V3 .nav-tabs-2 .nav-link.active::after {
  height: 5px;
  width: 100%;
  border-radius: 5px 5px 0 0;
  background-color: #5E79FF;
  content: "";
  position: absolute;
  bottom: 0px;
  left: 0px;
}

.V3 .site-content-mobile .cards-page .tabs-component .tab-header.float-sm-left,
.V3 .site-content-mobile .cards-page .tabs-component .tab-header.float-sm-right > div {
  margin-bottom: 10px !important;
  display: block;
  text-align: left;
  margin-right: 30px;
}

@media (min-width: 800.5px) {
  .V3
  .cards-page
  .tabs-component
  .tab-header.float-sm-right
  .tabs-nav-right-btn {
    margin-left: 15px;
  }
}

@media (max-width: 800px) {
  .V3 .cards-page .tabs-component .tab-header.float-sm-left {
    float: none !important;
  }

  .V3 .cards-page .tabs-component .tab-header.float-sm-right {
    margin-top: 10px;
    float: none !important;
  }

  .V3 .cards-page .tabs-component .tab-header.view-header-buttons {
    padding-left: 15px;
  }
}

.ex-cards-view .tab-content > .active {
  height: 100%;
}

.ex-cards-view .tab-content .box-block {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}

.ex-cards-view .tab-content {
  padding-bottom: 0px !important;
  height: 100%;
  background: #F1F1F7;
  padding: 10px;
  padding-top: 0;
  overflow-x: scroll;
}

@media (min-width: 591px) {
  .V3 .assessors-page .tabs-component .tab-header.float-sm-right .tabs-nav-right-btn {
    margin-left: 15px;
  }
}

@media (max-width: 590px) {
  .V3 .assessors-page .tabs-component .tab-header.float-sm-left {
    float: none !important;
  }

  .V3 .assessors-page .tabs-component .tab-header.float-sm-left,
  .V3 .assessors-page .tabs-component .tab-header.float-sm-right > div {
    margin-bottom: 10px !important;
    display: block;
    text-align: left;
    margin-right: 30px;
  }

  .V3 .assessors-page .tabs-component .tab-header.float-sm-right {
    margin-top: 10px;
    float: none !important;
  }

  .V3 .assessors-page .tabs-component .tab-header.view-header-buttons {
    padding-left: 15px;
  }
}

.assessor-type-block {
  width: 7%;
}

.nav-tabs {
  padding-bottom: 1px;
}

@media (min-width: 591px) {
  .V3 .customers-page .tabs-component .tab-header.float-sm-right .tabs-nav-right-btn {
    margin-left: 15px;
  }
}

@media (max-width: 590px) {
  .V3 .customers-page .tabs-component .tab-header.float-sm-left {
    float: none !important;
  }

  .V3 .customers-page .tabs-component .tab-header.float-sm-left,
  .V3 .customers-page .tabs-component .tab-header.float-sm-right > div {
    margin-bottom: 10px !important;
    display: block;
    text-align: left;
    margin-right: 30px;
  }

  .V3 .customers-page .tabs-component .tab-header.float-sm-right {
    margin-top: 10px;
    float: none !important;
  }

  .V3 .customers-page .tabs-component .tab-header.view-header-buttons {
    padding-left: 15px;
  }
}

.customers-page .tabs-nav-right-btn {
  margin-left: 2px !important;
}

@media (min-width: 591px) {
  .V3 .insurers-page .tabs-component .tab-header.float-sm-right .tabs-nav-right-btn {
    margin-left: 15px;
  }
}

@media (max-width: 590px) {
  .V3 .insurers-page .tabs-component .tab-header.float-sm-left {
    float: none !important;
  }

  .V3 .insurers-page .tabs-component .tab-header.float-sm-left,
  .V3 .insurers-page .tabs-component .tab-header.float-sm-right > div {
    margin-bottom: 10px !important;
    display: block;
    text-align: left;
    margin-right: 30px;
  }

  .V3 .insurers-page .tabs-component .tab-header.float-sm-right {
    margin-top: 10px;
    float: none !important;
  }

  .V3 .insurers-page .tabs-component .tab-header.view-header-buttons {
    padding-left: 15px;
  }
}

.insurers-page .tabs-nav-right-btn {
  margin-left: 2px !important;
}

.table-view .tabs-nav-right-search {
  min-width: 290px !important;
}

@media (min-width: 626px) {
  .tabs-nav-right-btn {
    margin-left: 15px !important;
  }
}

.nav-tabs,
.nav-tabs-2 {
  border-bottom: none !important;
}

.nav-tabs-2 .nav-link {
  border-bottom: none !important;
}

.dashboard-body-additional-block .tabs-component {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: static;
}

.dashboard-body-additional-block .dropdown-options,
.dashboard-body-additional-block .ex-options-button {
  width: 120px !important;
}

.dashboard-body-additional-block .tabs-component ul {
  display: flex;
}

.dashboard-body-additional-block .tabs-component {
  margin-top: 10px;
  background-color: white;
  padding: 0 !important;
  border: 1px solid rgba(28, 31, 57, 0.25);
}

.dashboard-body-additional-block .tabs-component::after {
  display: none;
}

.dashboard-body-additional-block .tab-header {
  width: 100%;
}

.dashboard-body-additional-block .tabs-nav-right-search {
  width: 100%;
  margin: 15px 0 !important;
}

.dashboard-body-additional-block .tab-content {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.estimates-edit-sub-tabs .tabs-component {
  position: static !important;
}

.estimates-edit-sub-tabs .tab-header {
  padding-bottom: 2px;
}

.estimates-edit-sub-tabs .tabs-component {
  padding-top: 0px;
  z-index: 999;
}

.estimates-edit-sub-tabs .tab-content {
  padding-top: 0px;
}

.estimates-edit-sub-tabs .tabs-component .nav-tabs-2 .nav-link {
  padding-top: 0px;
}

.estimates-template .template-tabs.mt-2 .nav-tabs.nav-tabs-2:first {
  margin-bottom: 0px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.estimates-template .template-tabs .tab-content {
  padding: 0;
}

.estimates-template .nav-tabs.nav-tabs-2 {
  border: none;
  height: 60px;
}

.estimates-template .tabs-component {
  position: inherit;
}

@media (min-width: 626px) {
  .V3 .invoice-view-page .tabs-component .tab-header.float-sm-right .tabs-nav-right-btn {
    margin-left: 15px;
  }
}

@media (max-width: 625px) {
  .V3 .invoice-view-page .tabs-component .tab-header.float-sm-left {
    float: none !important;
  }

  .V3 .invoice-view-page .tabs-component .tab-header.float-sm-left,
  .V3 .invoice-view-page .tabs-component .tab-header.float-sm-right > div {
    margin-bottom: 10px !important;
    display: block;
    text-align: left;
    margin-right: 30px;
  }

  .V3 .invoice-view-page .tabs-component .tab-header.float-sm-right {
    margin-top: 10px;
    float: none !important;
  }

  .V3 .invoice-view-page .tabs-component .tab-header.view-header-buttons {
    padding-left: 15px;
  }
}

.ex-invoice-excess .tabs-component {
  border-bottom: 1px solid #DCDCDC;
}

.V3 .form-control {
  height: 38px;
}

.V3 .form-control-plaintext {
  display: block;
  width: 100%;
  /* padding: $input-padding-y 0; */
  margin-bottom: 0; /* match inputs if this class comes on inputs with default margins */
  /* line-height: $input-line-height; */
  /* color: $input-plaintext-color; */
  background-color: transparent;
  border: solid transparent;
  /* border-width: $input-border-width 0; */
}

.V3 .form-control-plaintext.form-control-sm,
.V3 .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.V3 .card-header {
  display: flex;
  flex-flow: row wrap;
}

.V3 .card-header__right {
  margin-left: 50px;
}

.V3 .card-header .bx {
  font-size: 20px;
  vertical-align: middle;
}

.V3 .card-header:first-child .rs-btn-group {
  margin-top: 10px;
}

.V3 .table.b-table > thead > tr {
  /*background-color:rgb(239,239,241)!important;*/
  color: black !important;
}

.V3 .table.b-table > thead > tr > [aria-sort="none"] {
  background: url('data:image/svg+xml;base64,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') no-repeat top left;
  background-color: rgba(27, 30, 56, 0.12) !important;
  color: black !important;
  background-position: right calc(0.75rem / 2) center;
  padding-right: calc(0.75rem + 0.65em);
}

.V3 .table.b-table > thead > tr > [aria-sort="ascending"] {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMjUiIGQ9Ik0zLjIzODg3IDEzLjI2NTFWMi43MzM5TDEuMzA4NjMgNC43NjM0NEMxLjAwOTk4IDUuMDY2ODUgMC41MzUyNTIgNS4wNjI1MSAwLjI0MTY1NyA0Ljc1MzY5Qy0wLjA1MTkzODQgNC40NDQ4NyAtMC4wNTYwNjM1IDMuOTQ1NTMgMC4yMzIzODUgMy42MzEzOUwzLjQ2MTg4IDAuMjM0NDA3QzMuNzU5MSAtMC4wNzgxMzU3IDQuMjQwOSAtMC4wNzgxMzU3IDQuNTM4MTIgMC4yMzQ0MDdMNy43Njc2MiAzLjYzMTM5QzcuOTY1NDggMy44MzI0IDguMDQ0ODMgNC4xMzAwNyA3Ljk3NTE4IDQuNDA5OThDNy45MDU1MiA0LjY4OTkgNy42OTc3IDQuOTA4NSA3LjQzMTU4IDQuOTgxNzdDNy4xNjU0NyA1LjA1NTA0IDYuODgyNDcgNC45NzE1NyA2LjY5MTM3IDQuNzYzNDRMNC43NjExNCAyLjczNDdWMTMuMjY1OUw2LjY5MTM3IDExLjIzNTZDNi44ODI0NyAxMS4wMjc0IDcuMTY1NDcgMTAuOTQ0IDcuNDMxNTggMTEuMDE3MkM3LjY5NzcgMTEuMDkwNSA3LjkwNTUyIDExLjMwOTEgNy45NzUxOCAxMS41ODlDOC4wNDQ4MyAxMS44Njg5IDcuOTY1NDggMTIuMTY2NiA3Ljc2NzYyIDEyLjM2NzZMNC41MzgxMiAxNS43NjQ2QzQuMzk1NjkgMTUuOTE1MyA0LjIwMjAxIDE2IDQgMTZDMy43OTc5OSAxNiAzLjYwNDMxIDE1LjkxNTMgMy40NjE4OCAxNS43NjQ2TDAuMjMyMzg1IDEyLjM2NjhDMC4wMzQ1MjMzIDEyLjE2NTggLTAuMDQ0ODI5NSAxMS44NjgxIDAuMDI0ODI2IDExLjU4ODJDMC4wOTQ0ODE2IDExLjMwODMgMC4zMDIzMDYgMTEuMDg5NyAwLjU2ODQyMSAxMS4wMTY0QzAuODM0NTM2IDEwLjk0MzIgMS4xMTc1MyAxMS4wMjY2IDEuMzA4NjMgMTEuMjM0OEwzLjIzODg3IDEzLjI2NTFaIiBmaWxsPSIjMUIxRTM4Ii8+CjxwYXRoIGQ9Ik0xLjMxNDczIDQuNzYzNDRMMy4yNDQ5NyAyLjczMzlWOEw0Ljc2NzI0IDguMDAwM1YyLjczNDdMNi42OTc0NyA0Ljc2MzQ0QzYuODg4NTcgNC45NzE1NyA3LjE3MTU3IDUuMDU1MDQgNy40Mzc2OCA0Ljk4MTc3QzcuNzAzOCA0LjkwODUgNy45MTE2MiA0LjY4OTkgNy45ODEyOCA0LjQwOTk4QzguMDUwOTMgNC4xMzAwNyA3Ljk3MTU4IDMuODMyNCA3Ljc3MzcyIDMuNjMxMzlMNC41NDQyMiAwLjIzNDQwN0M0LjI0NyAtMC4wNzgxMzU3IDMuNzY1MiAtMC4wNzgxMzU3IDMuNDY3OTggMC4yMzQ0MDdMMC4yMzg0ODYgMy42MzEzOUMtMC4wNDk5NjMyIDMuOTQ1NTMgLTAuMDQ1ODM4IDQuNDQ0ODcgMC4yNDc3NTcgNC43NTM2OUMwLjU0MTM1MyA1LjA2MjUxIDEuMDE2MDggNS4wNjY4NSAxLjMxNDczIDQuNzYzNDRaIiBmaWxsPSIjMUIxRTM4Ii8+Cjwvc3ZnPgo=") no-repeat top left;
  background-color: rgba(27, 30, 56, 0.12) !important;
  color: black !important;
  background-position: right calc(0.75rem / 2) center;
  padding-right: calc(0.75rem + 0.65em);
}

.V3 .table.b-table > thead > tr > [aria-sort="descending"] {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMjUiIGQ9Ik0zLjI0NDk3IDEzLjI2NTFWMi43MzM5MUwxLjMxNDczIDQuNzYzNDVDMS4wMTYwOCA1LjA2Njg2IDAuNTQxMzU2IDUuMDYyNTIgMC4yNDc3NiA0Ljc1MzdDLTAuMDQ1ODM0OCA0LjQ0NDg3IC0wLjA0OTk2IDMuOTQ1NTMgMC4yMzg0ODkgMy42MzEzOUwzLjQ2Nzk4IDAuMjM0NDExQzMuNzY1MjEgLTAuMDc4MTMxOSA0LjI0NyAtMC4wNzgxMzE5IDQuNTQ0MjMgMC4yMzQ0MTFMNy43NzM3MiAzLjYzMTM5QzcuOTcxNTggMy44MzI0IDguMDUwOTMgNC4xMzAwNyA3Ljk4MTI4IDQuNDA5OTlDNy45MTE2MiA0LjY4OTkgNy43MDM4IDQuOTA4NSA3LjQzNzY5IDQuOTgxNzdDNy4xNzE1NyA1LjA1NTA0IDYuODg4NTggNC45NzE1NyA2LjY5NzQ4IDQuNzYzNDVMNC43NjcyNCAyLjczNDcxVjEzLjI2NTlMNi42OTc0OCAxMS4yMzU2QzYuODg4NTggMTEuMDI3NCA3LjE3MTU3IDEwLjk0NCA3LjQzNzY5IDExLjAxNzJDNy43MDM4IDExLjA5MDUgNy45MTE2MiAxMS4zMDkxIDcuOTgxMjggMTEuNTg5QzguMDUwOTMgMTEuODY4OSA3Ljk3MTU4IDEyLjE2NjYgNy43NzM3MiAxMi4zNjc2TDQuNTQ0MjMgMTUuNzY0NkM0LjQwMTc5IDE1LjkxNTMgNC4yMDgxMiAxNiA0LjAwNjEgMTZDMy44MDQwOSAxNiAzLjYxMDQyIDE1LjkxNTMgMy40Njc5OCAxNS43NjQ2TDAuMjM4NDg5IDEyLjM2NjhDMC4wNDA2MjY5IDEyLjE2NTggLTAuMDM4NzI2IDExLjg2ODEgMC4wMzA5Mjk2IDExLjU4ODJDMC4xMDA1ODUgMTEuMzA4MyAwLjMwODQwOSAxMS4wODk3IDAuNTc0NTI0IDExLjAxNjRDMC44NDA2MzkgMTAuOTQzMiAxLjEyMzYzIDExLjAyNjYgMS4zMTQ3MyAxMS4yMzQ4TDMuMjQ0OTcgMTMuMjY1MVoiIGZpbGw9IiMxQjFFMzgiLz4KPHBhdGggZD0iTTYuNzIyMzIgMTEuMjM2OUw0Ljc5MjA4IDEzLjI2NjRMNC43OTIwOCA4LjAwMDNMMy4yNjk4MSA4TDMuMjY5ODEgMTMuMjY1NkwxLjMzOTU3IDExLjIzNjlDMS4xNDg0NyAxMS4wMjg3IDAuODY1NDgxIDEwLjk0NTMgMC41OTkzNjYgMTEuMDE4NUMwLjMzMzI1MSAxMS4wOTE4IDAuMTI1NDI3IDExLjMxMDQgMC4wNTU3NzE0IDExLjU5MDNDLTAuMDEzODg0IDExLjg3MDIgMC4wNjU0Njg1IDEyLjE2NzkgMC4yNjMzMzEgMTIuMzY4OUwzLjQ5MjgyIDE1Ljc2NTlDMy43OTAwNSAxNi4wNzg0IDQuMjcxODUgMTYuMDc4NCA0LjU2OTA3IDE1Ljc2NTlMNy43OTg1NiAxMi4zNjg5QzguMDg3MDEgMTIuMDU0OCA4LjA4Mjg5IDExLjU1NTQgNy43ODkyOSAxMS4yNDY2QzcuNDk1NyAxMC45Mzc4IDcuMDIwOTcgMTAuOTMzNCA2LjcyMjMyIDExLjIzNjlaIiBmaWxsPSIjMUIxRTM4Ii8+Cjwvc3ZnPgo=") no-repeat top left;
  background-color: rgba(27, 30, 56, 0.12) !important;
  color: black !important;
  background-position: right calc(0.75rem / 2) center;
  padding-right: calc(0.75rem + 0.65em);
}

.V3 .tab-pane.tabs-component-panel .row .col-md-6 span {
  font-size: 12px;
}

.V3 .tab-pane .hint {
  font-size: 12px;
  font-weight: 600;
  color: gray;
}

.V3 .pagination li:first-child {
  display: none;
}

.V3 .pagination li:last-child {
  display: none;
}

.V3 .pagination li:nth-child(2) span {
  color: transparent;
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgNjIgKDEwMTAxMCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+QkFBNTVBQUEtMzI4Ny00N0Y5LTg2MkQtMDY2NDJFMjgzNTc5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJVSS1EZXNpZ24iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJEYXNoYm9hcmQtUmVkZXNpZ24tKFZpZXctQXNzZXNvcnMpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIwMi4wMDAwMDAsIC0xMTk3LjAwMDAwMCkiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJUb3AiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1MS4wMDAwMDAsIDIwOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NDMuMDAwMDAwLCA5ODIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImNoZXZyb24tbGVmdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC4wMDAwMDAsIDYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yLjc1Nyw3IEw3LjcwNywxMS45NSBDNy45NjY5NTY1OCwxMi4yMDEwNzQ1IDguMDcxMjEyNiwxMi41NzI4Nzc5IDcuOTc5Njk3MTYsMTIuOTIyNTA3MyBDNy44ODgxODE3MiwxMy4yNzIxMzY4IDcuNjE1MTM2NzYsMTMuNTQ1MTgxNyA3LjI2NTUwNzMyLDEzLjYzNjY5NzIgQzYuOTE1ODc3ODksMTMuNzI4MjEyNiA2LjU0NDA3NDQ3LDEzLjYyMzk1NjYgNi4yOTMsMTMuMzY0IEwwLjYzNiw3LjcwNyBDMC4yNDU2MTgwNjIsNy4zMTY1MDAxNSAwLjI0NTYxODA2Miw2LjY4MzQ5OTg1IDAuNjM2LDYuMjkzIEw2LjI5MywwLjYzNiBDNi42ODUzNzg4OSwwLjI1NzAyNzc5IDcuMzA5MDg0NzgsMC4yNjI0NDc2MjYgNy42OTQ4MTg1OCwwLjY0ODE4MTQyNSBDOC4wODA1NTIzNywxLjAzMzkxNTIyIDguMDg1OTcyMjEsMS42NTc2MjExMSA3LjcwNywyLjA1IEwyLjc1Nyw3IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') no-repeat center center;
}

.V3 .pagination li:nth-child(2) a {
  color: transparent;
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgNjIgKDEwMTAxMCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+QkFBNTVBQUEtMzI4Ny00N0Y5LTg2MkQtMDY2NDJFMjgzNTc5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJVSS1EZXNpZ24iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJEYXNoYm9hcmQtUmVkZXNpZ24tKFZpZXctQXNzZXNvcnMpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIwMi4wMDAwMDAsIC0xMTk3LjAwMDAwMCkiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJUb3AiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1MS4wMDAwMDAsIDIwOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NDMuMDAwMDAwLCA5ODIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImNoZXZyb24tbGVmdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC4wMDAwMDAsIDYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yLjc1Nyw3IEw3LjcwNywxMS45NSBDNy45NjY5NTY1OCwxMi4yMDEwNzQ1IDguMDcxMjEyNiwxMi41NzI4Nzc5IDcuOTc5Njk3MTYsMTIuOTIyNTA3MyBDNy44ODgxODE3MiwxMy4yNzIxMzY4IDcuNjE1MTM2NzYsMTMuNTQ1MTgxNyA3LjI2NTUwNzMyLDEzLjYzNjY5NzIgQzYuOTE1ODc3ODksMTMuNzI4MjEyNiA2LjU0NDA3NDQ3LDEzLjYyMzk1NjYgNi4yOTMsMTMuMzY0IEwwLjYzNiw3LjcwNyBDMC4yNDU2MTgwNjIsNy4zMTY1MDAxNSAwLjI0NTYxODA2Miw2LjY4MzQ5OTg1IDAuNjM2LDYuMjkzIEw2LjI5MywwLjYzNiBDNi42ODUzNzg4OSwwLjI1NzAyNzc5IDcuMzA5MDg0NzgsMC4yNjI0NDc2MjYgNy42OTQ4MTg1OCwwLjY0ODE4MTQyNSBDOC4wODA1NTIzNywxLjAzMzkxNTIyIDguMDg1OTcyMjEsMS42NTc2MjExMSA3LjcwNywyLjA1IEwyLjc1Nyw3IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') no-repeat center center;
}

.V3 .pagination li:nth-last-child(2) a {
  color: transparent;
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgNjIgKDEwMTAxMCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+RTlDRjczMTItMTZEQy00QTlGLUFGQTQtMzA2NTg4OUVBNkIzPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJVSS1EZXNpZ24iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJEYXNoYm9hcmQtUmVkZXNpZ24tKFZpZXctQXNzZXNvcnMpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQwOS4wMDAwMDAsIC0xMTk3LjAwMDAwMCkiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJUb3AiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1MS4wMDAwMDAsIDIwOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NDMuMDAwMDAwLCA5ODIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImNoZXZyb24tcmlnaHQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNS4wMDAwMDAsIDYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik01LjMxNCw3LjA3MSBMMC4zNjQsMi4xMjEgQy0wLjAxNDk3MjIwOTUsMS43Mjg2MjExMSAtMC4wMDk1NTIzNzM5LDEuMTA0OTE1MjIgMC4zNzYxODE0MjUsMC43MTkxODE0MjUgQzAuNzYxOTE1MjIzLDAuMzMzNDQ3NjI2IDEuMzg1NjIxMTEsMC4zMjgwMjc3OSAxLjc3OCwwLjcwNyBMNy40MzUsNi4zNjQgQzcuODI1MzgxOTQsNi43NTQ0OTk4NSA3LjgyNTM4MTk0LDcuMzg3NTAwMTUgNy40MzUsNy43NzggTDEuNzc4LDEzLjQzNSBDMS4zODU2MjExMSwxMy44MTM5NzIyIDAuNzYxOTE1MjIzLDEzLjgwODU1MjQgMC4zNzYxODE0MjUsMTMuNDIyODE4NiBDLTAuMDA5NTUyMzczOSwxMy4wMzcwODQ4IC0wLjAxNDk3MjIwOTUsMTIuNDEzMzc4OSAwLjM2NCwxMi4wMjEgTDUuMzE0LDcuMDcxIFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') no-repeat center center;
}

.V3 .pagination li:nth-last-child(2) span {
  color: transparent;
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCA4IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgNjIgKDEwMTAxMCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+RTlDRjczMTItMTZEQy00QTlGLUFGQTQtMzA2NTg4OUVBNkIzPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJVSS1EZXNpZ24iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJEYXNoYm9hcmQtUmVkZXNpZ24tKFZpZXctQXNzZXNvcnMpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQwOS4wMDAwMDAsIC0xMTk3LjAwMDAwMCkiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJUb3AiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1MS4wMDAwMDAsIDIwOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NDMuMDAwMDAwLCA5ODIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImNoZXZyb24tcmlnaHQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxNS4wMDAwMDAsIDYuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik01LjMxNCw3LjA3MSBMMC4zNjQsMi4xMjEgQy0wLjAxNDk3MjIwOTUsMS43Mjg2MjExMSAtMC4wMDk1NTIzNzM5LDEuMTA0OTE1MjIgMC4zNzYxODE0MjUsMC43MTkxODE0MjUgQzAuNzYxOTE1MjIzLDAuMzMzNDQ3NjI2IDEuMzg1NjIxMTEsMC4zMjgwMjc3OSAxLjc3OCwwLjcwNyBMNy40MzUsNi4zNjQgQzcuODI1MzgxOTQsNi43NTQ0OTk4NSA3LjgyNTM4MTk0LDcuMzg3NTAwMTUgNy40MzUsNy43NzggTDEuNzc4LDEzLjQzNSBDMS4zODU2MjExMSwxMy44MTM5NzIyIDAuNzYxOTE1MjIzLDEzLjgwODU1MjQgMC4zNzYxODE0MjUsMTMuNDIyODE4NiBDLTAuMDA5NTUyMzczOSwxMy4wMzcwODQ4IC0wLjAxNDk3MjIwOTUsMTIuNDEzMzc4OSAwLjM2NCwxMi4wMjEgTDUuMzE0LDcuMDcxIFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') no-repeat center center;
}

.V3 .page-link {
  box-sizing: border-box;
  padding: 0px;
  height: 27px;
  width: 27px;
  font-size: 12px;
  font-weight: bold;
  border: 2px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background-color: rgba(27, 30, 56, 0.03);
  display: inline-flex;
  justify-content: center;
  margin-left: 10px;
  align-items: center;
}

.V3 .page-item.active .page-link,
.V3 .page-item.active .page-link:hover,
.V3 .page-item.active .page-link:focus {
  background-color: #5E79FF !important;
  color: white;
  border: none;
}

.V3 .b-table .td-warn {
  font-size: 11px;
  color: red;
}

.V3 .btn_edit {
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMTkgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA2MiAoMTAxMDEwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5BQkU0Q0UxRi0yMDAyLTQ2QTEtQTVBMS0yRTUwMDg0MDQ5MTE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9IlVJLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRhc2hib2FyZC1SZWRlc2lnbi0oVmlldy1Bc3Nlc29ycykiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzc1LjAwMDAwMCwgLTEwMDYuMDAwMDAwKSIgZmlsbD0iIzFCMUUzOCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IlJvdy0wMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY1LjAwMDAwMCwgMTAwNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJwZW5jaWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMTAuMDAwMDAwLCAxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi4yMzgsNS40NzIgTDMuMiwxNC41MSBMMi42MDksMTYuNTI2IEw0LjU4NCwxNS45NTUgTDEzLjY1Miw2Ljg4NyBMMTIuMjM4LDUuNDcyIFogTTEzLjc4LDMuOTMgTDE1LjE5NCw1LjM0NCBMMTYuNTEyLDQuMDI2IEMxNi43MDcxOTEsMy44MzA3NTAwNyAxNi43MDcxOTEsMy41MTQyNDk5MyAxNi41MTIsMy4zMTkgTDE1LjgwNCwyLjYxMiBDMTUuNjA4NzUwMSwyLjQxNjgwOTAzIDE1LjI5MjI0OTksMi40MTY4MDkwMyAxNS4wOTcsMi42MTIgTDEzLjc4MSwzLjkzIEwxMy43OCwzLjkzIFogTTE3LjIxOSwxLjE5OCBMMTcuOTI2LDEuOTA1IEMxOC45MDE5NTQ4LDIuODgxMjQ5NjMgMTguOTAxOTU0OCw0LjQ2Mzc1MDM3IDE3LjkyNiw1LjQ0IEw1LjYzNCwxNy43MzMgTDEuNDE0LDE4Ljk1MyBDMS4wNjM2NjE3LDE5LjA1NDAxMiAwLjY4NjExMjg5NCwxOC45NTYzNDA0IDAuNDI4NzExMjksMTguNjk4MTA2NSBDMC4xNzEzMDk2ODYsMTguNDM5ODcyNSAwLjA3NDg1NzQ1MiwxOC4wNjIwMTA0IDAuMTc3LDE3LjcxMiBMMS40MjUsMTMuNDU3IEwxMy42ODUsMS4xOTcgQzE0LjY2MTI0OTYsMC4yMjEwNDUxNTQgMTYuMjQzNzUwNCwwLjIyMTA0NTE1NCAxNy4yMiwxLjE5NyBMMTcuMjE5LDEuMTk4IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=') no-repeat top left;
  border: none;
  height: 20px;
}

.V3 .btn_save {
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNNTA2LjUxMywxMjQuMTJMMzg3Ljg3OSw1LjQ4NmMtMC4wMDEtMC4wMDEtMC4wMDMtMC4wMDMtMC4wMDUtMC4wMDRDMzg0LjQ2NywyLjA3NiwzNzkuNjk3LDAsMzc0LjYzNCwwDQoJCQljLTE1LjAxOCwwLTM0MS42LDAtMzU1LjkwMiwwQzguMzg3LDAsMCw4LjM4NywwLDE4LjczMnY0NzQuNTM3QzAsNTAzLjYxMyw4LjM4Nyw1MTIsMTguNzMyLDUxMmMyMi41NjMsMCw0NTIuMzUzLDAsNDc0LjUzNywwDQoJCQljMTAuMzQ1LDAsMTguNzMyLTguMzg3LDE4LjczMi0xOC43MzJWMTM3LjM2NkM1MTIsMTMyLjM5OCw1MTAuMDI3LDEyNy42MzQsNTA2LjUxMywxMjQuMTJ6IE0xNTYuMDk4LDM3LjQ2M2gxOTkuODA1djExMC44MjMNCgkJCUgxNTYuMDk4VjM3LjQ2M3ogTTQwMC40NSw0NzQuNTM3aC0yODguOVYzMTYuOTM1aDI4OC45VjQ3NC41Mzd6IE00NzQuNTM3LDQ3NC41MzdoLTM2LjYyM1YyOTguMjA0DQoJCQljMC0xMC4zNDUtOC4zODctMTguNzMyLTE4LjczMi0xOC43MzJIOTIuODE4Yy0xMC4zNDUsMC0xOC43MzIsOC4zODctMTguNzMyLDE4LjczMnYxNzYuMzMzSDM3LjQ2M1YzNy40NjNoODEuMTcxdjEyOS41NTUNCgkJCWMwLDEwLjM0NSw4LjM4NywxOC43MzIsMTguNzMyLDE4LjczMmgyMzcuMjY4YzEwLjM0NSwwLDE4LjczMi04LjM4NywxOC43MzItMTguNzMyVjYzLjk1NGw4MS4xNzEsODEuMTcxVjQ3NC41Mzd6Ii8+DQoJPC9nPg0KPC9nPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGQ9Ik0zMDkuNTE0LDU1LjAxNWMtMTAuMzQ1LDAtMTguNzMyLDguMzg3LTE4LjczMiwxOC43MzJ2MzguMjU2YzAsMTAuMzQ2LDguMzg2LDE4LjczMiwxOC43MzIsMTguNzMyDQoJCQljMTAuMzQ1LDAsMTguNzMyLTguMzg3LDE4LjczMi0xOC43MzJWNzMuNzQ3QzMyOC4yNDYsNjMuNDAyLDMxOS44NTksNTUuMDE1LDMwOS41MTQsNTUuMDE1eiIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K') no-repeat center left;
  border: none;
  height: 20px;
}

.V3 .btn_trush {
  background: url('data:image/svg+xml;base64,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') no-repeat center left;
  border: none;
  height: 20px;
  width: 20px;
}

.V3 .icon_envelope {
  mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC);
  mask-mode: alpha;
  mask-repeat: no-repeat;
  mask-size: 80%;
  height: 20px;
  width: 20px;
}
</style>

<style>
/* Nav */
.nav-1 {
  text-align: center;
}

.nav-1 .nav-link {
  display: block;
  padding: 1rem 0;
  border-right: 1px solid rgba(0, 0, 0, 0.25);
}

.nav-1 .nav-link span {
  display: inline-block;
  font-size: 1.5rem;
}

.nav-1 .nav-link:focus,
.nav-1 .nav-link:hover {
  color: #3E70C9;
  background-color: #F5F5F5;
}

.nav-1 .active,
.nav-1 .active:focus,
.nav-1 .active:hover {
  color: #FFFFFF;
  background-color: #3E70C9;
}

.nav-2 {
  text-align: center;
}

.nav-2 .nav-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
}

.nav-2 .nav-link {
  display: block;
  padding: 1rem 0;
  color: #777777;
}

.nav-2 .nav-link span {
  display: inline-block;
  font-size: 1.5rem;
}

.nav-2 .nav-link:focus,
.nav-2 .nav-link:hover {
  color: #3E70C9;
  background-color: #F5F5F5;
}

.nav-2 .active .nav-link,
.nav-2 .active .nav-link:focus,
.nav-2 .active .nav-link:hover {
  color: #FFFFFF;
  background-color: #3E70C9;
}

.nav-3 {
  text-align: center;
}

.nav-3 .nav-link {
  display: block;
  padding: 1rem 0;
}

.nav-3 .nav-link .avatar {
  display: inline-block;
}

.nav-3 .nav-link i {
  font-size: 1.25rem;
}

.nav-3 .nav-link:focus,
.nav-3 .nav-link:hover {
  color: #3E70C9;
  background-color: #F5F5F5;
}

.nav-3 .active .nav-link,
.nav-3 .active .nav-link:focus,
.nav-3 .active .nav-link:hover {
  color: #FFFFFF;
  background-color: #3E70C9;
}

.V3 .nav-4 .nav-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
}

.V3 .nav-4 .nav-link {
  display: block;
  padding: 1rem 1.5rem;
  color: #777777;
  border-left: 3px solid transparent;
}

.V3 .nav-4 .nav-link i {
  margin-right: 0.75rem;
}

.V3 .nav-4 .nav-link:focus,
.V3 .nav-4 .nav-link:hover {
  background-color: #F5F5F5;
}

.V3 .nav-4 .active .nav-link,
.V3 .nav-4 .active .nav-link:focus,
.V3 .nav-4 .active .nav-link:hover {
  color: #3E70C9;
  border-color: #3E70C9;
}

.nav-5 .nav-title {
  padding: 0.5rem 1.5rem;
  background-color: #EEEEEE;
  font-size: 90%;
  text-transform: uppercase;
}

.nav-5 .nav-link {
  display: block;
  padding: 0.5rem 1.5rem;
  color: #777777;
}

.nav-5 .nav-link i {
  margin-right: 0.75rem;
}

.nav-5 .nav-link:focus,
.nav-5 .nav-link:hover {
  color: #3E70C9;
}

.nav-5 .active .nav-link,
.nav-5 .active .nav-link:focus,
.nav-5 .active .nav-link:hover {
  color: #3E70C9;
}

.nav-6 .nav-item {
  display: block;
  position: relative;
  text-align: center;
}

.nav-6 .gradient {
  position: absolute;
  z-index: 9;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0.8;
}

.nav-6 .nav-link {
  display: block;
  position: relative;
  z-index: 10;
  padding: 3rem 1.5rem;
  color: #FFFFFF;
  text-transform: uppercase;
}

.nav-6 .nav-link span {
  font-size: 90%;
  text-transform: none;
}

.nav-6 .nav-link:focus,
.nav-6 .nav-link:hover {
  color: rgba(255, 255, 255, 0.9);
}

.nav-6 .active .nav-link,
.nav-6 .active .nav-link:focus,
.nav-6 .active .nav-link:hover {
  color: #FFFFFF;
}

.nav-7 .nav-item {
  border-left: 3px solid transparent;
}

.nav-7 .nav-link {
  display: block;
  padding: 0.75rem 1.5rem;
  color: #777777;
}

.nav-7 .nav-link i {
  margin-right: 0.75rem;
  color: #3E70C9;
}

.nav-7 .nav-item ul {
  display: none;
  margin: 0;
  padding: 0 0 0.75rem 27px;
  list-style: none;
}

.nav-7 .nav-item.opened {
  display: block;
  background-color: #F5F5F5;
  border-color: #3E70C9;
}

.nav-7 .nav-item.opened ul {
  display: block;
}

.nav-7 .nav-link:focus,
.nav-7 .nav-link:hover {
  color: #3E70C9;
}

.nav-7 .active .nav-link,
.nav-7 .active .nav-link:focus,
.nav-7 .active .nav-link:hover {
  color: #3E70C9;
}

.nav-8 .nav-link {
  display: block;
  padding: 0.5rem 0;
  color: #777777;
}

.nav-8 .nav-link i {
  margin-right: 0.75rem;
}

.nav-8 .nav-link:focus,
.nav-8 .nav-link:hover {
  color: #3E70C9;
}

.nav-8 .active .nav-link,
.nav-8 .active .nav-link:focus,
.nav-8 .active .nav-link:hover {
  color: #3E70C9;
  background-color: transparent;
}
</style>

<style>
/*
    Options dropdown
     */
.V3 .dropdown-options {
  height: 39px;
  width: 149px;
  margin-right: 15px;
}

.V3 .dropdown-options .btn {
  box-sizing: border-box;
  border: 1px solid #5E79FF;
  border-radius: 3px;
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
  width: 149px;
  text-align: left;
  background-color: #FFFFFF;
}

.V3 .dropdown-options .btn:hover {
  outline: 1px solid #5E79FF !important;
}

.V3 .dropdown-options .dropdown-menu {
  width: 148px;
  border-radius: 3px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 4px 0 rgba(27, 30, 56, 0.15);
  min-width: 148px;
  margin: 5px 0 0;
  text-align: left;
  list-style: none;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  z-index: 110;
  padding: 0 !important;
}

.V3 .dropdown-options .dropdown-menu .dropdown-item {
  display: inline-block;
  position: relative;
  width: 100%;
  min-height: 38px;
  padding: 10px 14px 8px 14px;
  clear: both;
  color: #1C1F39;
  text-align: inherit;
  white-space: normal;
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  background: 0 0;
  border: 0;
  cursor: pointer;
}

.V3 .dropdown-options .dropdown-menu .dropdown-item:hover {
  background-color: rgba(94, 121, 255, 0.1);
  color: #5E79FF;
  font-weight: bold;
}

.V3 .page-header-nav-options .dropdown-options {
  width: 80px;
  margin-right: 0px;
}

.V3 .page-header-nav-options .dropdown-options .btn {
  padding-right: 5px;
  padding-left: 5px;
  width: 80px;
}

.V3 .page-header-nav-options .dropdown-options button .dropdown-arrow {
  width: 18px !important;
}

.V3 .page-header-nav-options .dropdown-menu {

}

.V3 .page-header-nav-options .dropdown-menu .dropdown-item {

}

</style>

<style>
/* WIZARD STEPPER
    *******************************/

.pull-left {
  float: left !important;
}

.pull-right {
  float: right !important;
}

.clearfix::after {
  display: block;
  content: "";
  clear: both;
}

/* Header Steps
    *******************************/
.wizard {
  position: relative;
  width: 100%;
}

.V3 .card-new .wizard .sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 140px;
  z-index: 1000;
  background-color: #FFFFFF;
  height: 80px;
}

.wizard__divider {
  width: 100%;
  height: 10px;
  border: 5px solid rgba(27, 30, 56, 0.1);
}

.wizard__steps {
  list-style-type: none;
  text-align: justify;
  -ms-text-justify: distribute-all-lines;
  text-justify: distribute-all-lines;
  padding: 0;
  height: 70px;
  min-width: 417px;
  width: 417px;
  margin: 0 auto;
  position: relative;
}

.stretch {
  width: 100%;
  display: inline-block;
  font-size: 0;
  line-height: 0
}

.wizard__step {
  vertical-align: top;
  display: inline-block;
  text-align: center;
  position: relative;
}

.wizard__step:not(:first-child) .wizard__step__line {
  position: absolute;
  width: 100%;
  left: -50%;
  top: 17px;
  height: 10px;
  background-color: rgba(27, 30, 56, 0.12);
}

.wizard__step .wizard__step__line__mobile__right {
  display: none;
  position: absolute;
  width: 100px;
  left: 27px;
  top: 8px;
  height: 10px;
  background-color: rgba(27, 30, 56, 0.12);
  border-radius: 0 10px 10px 0;
}

.wizard__step .wizard__step__line__mobile__left {
  display: none;
  position: absolute;
  width: 100px;
  left: -100px;
  top: 8px;
  height: 10px;
  background-color: rgba(27, 30, 56, 0.12);
  border-radius: 10px 0 0 10px;
}

@media screen and (max-width: 399px) {
  .wizard__step .wizard__step__line__mobile__right {
    display: block;
  }

  .wizard__step .wizard__step__line__mobile__left {
    display: block;
  }
}

.wizard__step:not(:first-child):not(:last-child) .wizard__step__line {
  border-radius: 5px 0 0 5px;
}

.wizard__step:last-child .wizard__step__line {
  border-radius: 0 5px 5px 0;
}

.wizard__step:nth-child(2) .wizard__step__line {
  border-radius: 5px;
}

.wizard__step__indicator {
  box-sizing: content-box;
  display: none;
  width: 26px;
  height: 26px;
  background-color: #51ABE4;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  margin-left: -10px;
  top: 7px;
  z-index: 1;
}

.wizard__step__indicator i {
  font-size: 23px;
  color: #5E79FF;
}

.wizard__step.active.current .wizard__step__indicator {
  background-color: #FFFFFF;
  display: block;
  border: 2px solid #5E79FF;
}

.wizard__step.active:not(:first-child) .wizard__step__line {
  background-color: #5E79FF; /* green */
}

.wizard__step__label {
  position: absolute;
  left: 50%;
  margin-left: -10px;
  top: 48px;
  z-index: 1;
  font-weight: bold;
}

.wizard__step__label div {
  margin-left: -50%;
}

/* Wizard body
    *******************************/
.wizard__body {
  position: relative;
  /*min-width: 573px;*/
  width: 573px;
  margin: 0px auto 0 auto;
  padding-top: 30px;
}

.card-new-body .wizard__body {
  width: 640px;
}

@media screen and (max-width: 876px) {
  .card-new-body .wizard__body {
    width: 500px;
  }
}

@media screen and (max-width: 500px) {
  .card-new-body .wizard__body {
    width: 95%;
  }
}

@media screen and (max-width: 500px) and (min-width: 400px) {
  .V3 .wizard__steps {
    height: 90px !important;
  }

  .V3 .wizard__body {
    padding-top: 30px !important;
  }
}

.wizard__body__step {
  /*padding: 16px;*/
}

.wizard__body .wizard__body__step .header {
  color: #1C1F39;
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  margin-bottom: 5px;
}

.wizard__body .wizard__body__step .subheader {
  color: rgba(28, 31, 57, 0.75);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 15px;
}

.wizard__body span.indicate {
  color: #FF5E5E;
}

.wizard__arrow {
  position: absolute;
  display: block;
  width: 30px;
  height: 30px;
  border: 1px solid #AEBAC4;
  top: 85px; /* height of step + body margin -15 */
  border-top-right-radius: 5px;
  background-color: #FFFFFF;
  border-left: none;
  border-bottom: none;
  transform: rotate(-45deg);
  z-index: 2;
  -webkit-transition: left 0.3s;
  -o-transition: left 0.3s;
  transition: left 0.3s;
}

.wizard__body__actions {
  position: absolute;
  bottom: 0px;
  height: 50px;
  width: 100%;
  border-top: 1px solid #AEBAC4;
  background-color: #B9C7D2;
}

.wizard__body__actions a {
  width: 120px;
  height: 100%;
  display: block;
  background-color: #51ABE4;
  color: white;
  font-weight: bold;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  -webkit-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.wizard__body__actions a.disabled {
  cursor: not-allowed;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  opacity: 0.5;
}

.wizard__body__actions a > .vgw-icon, .wizard__body__actions a > span {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}

.wizard__body__actions .vgw-icon::after {
  position: absolute;
  content: "";
  transform: rotate(-45deg);
  width: 8px;
  height: 8px;
  top: 50%;
  margin-top: -5px;
}

.vgw-icon.vgw-next::after {
  border-bottom: 2px solid white;
  border-right: 2px solid white;
}

.vgw-icon.vgw-prev::after {
  border-top: 2px solid white;
  border-left: 2px solid white;
  left: -10px;
}

.wizard__body__actions a:hover {
  background-color: #357FAE;
}

.wizard__body__actions a.final-step {
  background-color: #6EB165;
}

/* mobile */
.wizard__body.vgw-mobile {
  padding-left: 15px;
  padding-right: 15px;
  margin: 0px auto;
  min-width: auto;
  width: auto;
}

.wizard__step.vgw-mobile {
  display: none;
}

.wizard__step .wizard__step__line.vgw-mobile {
  display: none;
}

.wizard__step.active.vgw-mobile {
  display: inline-block;
}

.V3 .wizard-header {
  position: relative;
  margin-bottom: 15px;
}

.V3 .wizard-header .wizard-header-name {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 5px;
}

.V3 .wizard-header .wizard-subheader-name {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.V3 .wizard-header .wizard-header-button {
  position: absolute;
  bottom: 3px;
  right: 0;
  margin-left: 15px;
}

.V3 .wizard__body table.b-table thead th {
  height: 48px;
}

.V3 table.table.b-table > thead > tr > th {
  background-color: rgba(27, 30, 56, 0.12) !important;
}

.V3 table.table td.checkbox,
.V3 table.table th.checkbox {
  width: 25px;
  padding: 10px 0px 10px 15px;
}

@media (max-width: 417px) {
  .V3 .wizard__steps {
    width: auto;
    min-width: auto;
  }
}
</style>

<style>
/* =================================================================
      Base
    ================================================================= */

html.V3, body.V3,
html, body {
  width: 100%;
  height: 100%;
  font-size: 13px;
}

html.V3,
html {
  position: relative;
  font-size: 13px;
}

.V3 body, body {
  /* background-color: #bbc2ce; */
  font-family: 'Nunito Sans', sans-serif;
  color: #1C1F39;
}

.V3 body,
.V3 .btn {
  font-size: 13px;
}

.V3 .wrapper {
  position: relative;
  min-height: 100%;
  overflow: visible;
  /* background-color: #e8ebf0;*/
}

.V3 .boxed-wrapper .wrapper {
  margin-left: auto;
  margin-right: auto;
  max-width: 1270px;
}

* {
  outline: none !important;
  margin: 0;
  padding: 0;
}

a:focus,
a:hover,
a:active {
  text-decoration: none;
}

.V3 .content-appear > .wrapper {
  -webkit-transform: rotateY(10deg) translateX(-150px);
  transform: rotateY(10deg) translateX(-150px);
  -webkit-transition: 0.4s all ease-in-out;
  transition: 0.4s all ease-in-out;
  opacity: 0;
}

.V3 .content-appearing > .wrapper {
  -webkit-transform: rotateY(0deg) translateX(0);
  transform: rotateY(0deg) translateX(0);
  opacity: 1;
}

.V3 .preloader {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: rgba(255, 255, 255, 0.8);
}

.V3 .preloader:after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30px;
  height: 30px;
  border: 2px solid #20B9AE;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: rotate 425ms infinite linear;
  -o-animation: rotate 425ms infinite linear;
  -ms-animation: rotate 425ms infinite linear;
  -webkit-animation: rotate 425ms infinite linear;
  -moz-animation: rotate 425ms infinite linear;
}

.V3 .site-overlay {
  display: none;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.V3 .site-sidebar-opened .site-sidebar-mobile .site-overlay {
  display: block;
}

@media (max-width: 991px) {
  html.V3 {
    overflow-x: hidden;
  }
}
</style>

<style>
/*
    From bootstrap
     */
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }

  .float-sm-right {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }

  .float-md-right {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }

  .float-lg-right {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }

  .float-xl-right {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }
}
</style>

<style>
/*
    =======================================
    Pin Images
    ==========================================
     */
.image-pin-area {
  position: fixed;
  width: 220px;
  height: calc(100% - 60px);
  overflow-y: auto;
  display: block;
  background: linear-gradient(180deg, #1C1F3A 0%, #161931 53.69%, #282C48 100%);
  left: 0;
  z-index: 999999;
  top: 60px;
  padding: 15px;
}

.image-pin-area .dropzone {
  padding-top: 0;
  margin-bottom: 15px;
}

.image-pin-area .dropzoneContainer {
  margin: 0;
  padding-top: 10px;
}

.image-pin-area .dropzone .dz-preview {
}

.image-pin-area .dropzone .dz-message {
  margin-top: 45px;
}

.image-pin-area .dropzone .dz-message p {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: normal;
  line-height: 19px;
  margin-top: 11px;
}

.image-pin-area .dropify-wrapper {
  width: auto;
  height: auto;
  border-radius: 5px;
  border-width: 0;
  background-color: #31344B !important;
  margin-bottom: 25px;
}

.image-pin-area .col-sm-3 {
  width: 100%;
  padding: 0;
}

.image-pin-area .col-sm-3 .box.box-block.bg-grey {
  padding: 0;
}

.image-pin-area .col-sm-3 .box.box-block.bg-grey .wrap.img-fluid {
  width: 100%;
  height: auto;
}

.pin-image {
  display: flex;
  align-items: center;
  position: relative;
  color: #34495E;
  height: 27px;
  font-weight: 600;
  font-size: 13px;
  padding-top: 8px;
  padding-left: 35px;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

@media screen and (max-width: 991px) {
  .pin-image {
    margin-bottom: 15px;
  }
}

/* Hide the browser's default checkbox */
.pin-image input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.pin-checkmark {
  position: absolute;
  top: 5px;
  left: 0;
  height: 25px;
  width: 25px;
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background-color: white;
  border: 1px solid #DFDFDF;
}

/* On mouse-over, add a grey background color */
.pin-image:hover input ~ .pin-checkmark {
  background-color: #CCCCCC;
  border-color: #CCCCCC;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

/* When the checkbox is checked, add a blue background */
.pin-image input:checked ~ .pin-checkmark {
  background-color: #5E79FF;
  border-color: #5E79FF;
}

/* Create the checkmark/indicator (hidden when not checked) */
.V3 .pin-checkmark i {
  margin: auto;
  width: 16px;
  margin-top: 3px;
  display: none;
}

.V3 #job-card .pin-checkmark i {
  font-size: 26px;
  color: white;
  margin-left: -2px;
  margin-top: -2px;
}

/* Show the checkmark when checked */
.pin-image input:checked ~ .pin-checkmark i {
  display: block;
}

/* Style the checkmark/indicator */
.pin-image .pin-checkmark:after {
}
</style>
<style>
.V3 .navbar-brand,
.V3 .nav-link {
  -webkit-transition: none;
  transition: none;
}
</style>
<style>
/*
    Preview table
     */

.V3 .preview table {
  width: 100%;
}


.V3 .preview .table-preview td,
.V3 .preview .table-preview tr,
.V3 .preview .table-preview th {
  margin: 0px;
  padding: 0px;
  vertical-align: top;
}

.v3 .w-auto {
  width: auto !important;
}

.V3 .preview div,
.V3 .preview div span {
  color: #1C1F39;
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
}

.V3 .preview .table-preview > tr > td {
  border-bottom: 2px solid rgba(27, 30, 56, 0.1);
  border-top: none;
}

.V3 .preview .table-preview table.nobrd > tr > td,
.V3 .preview .table-preview .nobrd > td,
.V3 .preview .table-preview .nobrd > th {
  border: none !important;
}

.V3 .preview .preview-header .preview-header-title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 2px;
  line-height: 24px;
  margin-bottom: 20px;
}

.V3 .preview .preview-header .preview-header-business-name {
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
}

.V3 .preview .preview-header .preview-header-item .preview-header-item-name {
  font-weight: 700;
}

.V3 .preview .preview-header .preview-header-delimiter {
  height: 20px;
}

.V3 .preview .preview-header {
  padding-bottom: 30px !important;
  padding-left: 36px;
}

.V3 .preview .preview-head-name {
  height: 36px;
  border-radius: 3px;
  background-color: rgba(27, 30, 56, 0.1);
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  padding: 9px 15px 8px 15px;
  border-bottom: 1px solid #FFFFFF;
}

.V3 .preview .preview-subhead-name {
  height: 36px;
  border-radius: 3px;
  background-color: rgba(27, 30, 56, 0.1);
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
  padding: 9px 15px 14px 15px;
  border-bottom: 1px solid #FFFFFF;
}

.V3 .preview .preview-subhead-unit-price {
  padding: 9px 5px 14px 5px !important;
}

.V3 .preview .preview-item-name {
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  padding: 13px 15px 4px 15px;
}

.V3 .preview .preview-item-value {
  font-size: 12px;
  line-height: 16px;
  padding: 13px 15px 4px 15px;
}

.V3 .preview .preview-align-right {
  text-align: right;
}

.V3 .preview .preview-amount-header {
  text-align: right;
  padding-right: 50px;
}

.V3 .preview .preview-amount {
  text-align: right;
  padding-right: 60px;
}


.V3 .preview .preview-delimiter {
  height: 20px;
}

.V3 .preview .w-33 {
  width: 33% !important;
}

.V3 .preview .w-25 {
  width: 25% !important;
}

.V3 .preview .preview-total-plus {
  color: #000000;
  position: absolute;
  top: -20px;
  left: 20px;
}

.V3 .preview .preview-terms-delimeter {
  box-sizing: border-box;
  height: 1px;
  width: 100%;
  border-top: 1px solid rgba(27, 30, 56, 0.25);
  margin-top: 40px;
  margin-bottom: 25px;
}

.V3 .preview .preview-terms-header {
  height: 19px;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  padding-bottom: 15px;
}

.V3 .preview .preview-terms {
  padding-right: 47px;
}

.V3 .notf-icon {
  width: 20px;
  height: 16px;
  position: relative;
  display: inline-block;
}

.V3 .notf-icon .tooltip-text {
  visibility: hidden;
  width: 200px;
  background-color: white;
  color: black;
  border: 1px solid #5E79FF;
  border-radius: 3px;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
  position: absolute;
  z-index: 1;
  text-align: center;
  padding: 5px;
  margin-left: -94px;
}

.V3 .notf-icon .tooltip-text.pos-top {
  bottom: 150%;
}

.V3 .notf-icon .tooltip-text.pos-top:after {
  content: ' ';
  position: absolute;
  top: 100%;
  left: 50%;
  marrgin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #5E79FF transparent transparent transparent;
}

.V3 .notf-icon .tooltip-text.pos-bottom {
  top: 150%;
}

.V3 .notf-icon .tooltip-text.pos-bottom:after {
  content: ' ';
  position: absolute;
  bottom: 100%;
  left: 50%;
  marrgin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #5E79FF transparent;
}

.V3 .notf-icon:hover .tooltip-text {
  visibility: visible;
}

/********Table View***************/
.font-weight-600 {
  font-weight: 600;
}

.table-view .tabs-nav-right-btn {
  margin-left: 0;
}

.add-button-table i {
  font-weight: bolder !important;
}

.table-view .search-input {
  box-sizing: border-box;
  height: 38px;
  width: 191px;
  border: 1px solid #1C1F39;
  border-radius: 3px;
}

.table-view .tabs-nav-right-search {
  min-width: 191px !important;
}

.table-view .add-button-table {
  height: 38px;
  position: relative;
  bottom: 1px;
  border-radius: 3px;
  background-color: #5E79FF;
  color: #FFFFFF;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  padding-left: 7px;

}

.table-view .td-text {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
}

.table-view .th-text {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
}


.settings-page-users .user-avatar-section {
  padding-left: 0 !important;
}

.settings-page-users .user-avatar-section button {
  width: 100%;
  border-radius: 3px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: bold;
  background-color: #FF5E5E !important;
  margin-top: 10px;
  height: 30px;
}

</style>

<style>
/*settings*/

.settings-page .selected-td {
  color: #5E79FF;
  background-color: #E5F1FB !important;
}

.settings-page .btn-edit {
  background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMTkgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA2MiAoMTAxMDEwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5BQkU0Q0UxRi0yMDAyLTQ2QTEtQTVBMS0yRTUwMDg0MDQ5MTE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9IlVJLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRhc2hib2FyZC1SZWRlc2lnbi0oVmlldy1Bc3Nlc29ycykiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzc1LjAwMDAwMCwgLTEwMDYuMDAwMDAwKSIgZmlsbD0iIzFCMUUzOCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IlJvdy0wMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY1LjAwMDAwMCwgMTAwNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJwZW5jaWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMTAuMDAwMDAwLCAxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi4yMzgsNS40NzIgTDMuMiwxNC41MSBMMi42MDksMTYuNTI2IEw0LjU4NCwxNS45NTUgTDEzLjY1Miw2Ljg4NyBMMTIuMjM4LDUuNDcyIFogTTEzLjc4LDMuOTMgTDE1LjE5NCw1LjM0NCBMMTYuNTEyLDQuMDI2IEMxNi43MDcxOTEsMy44MzA3NTAwNyAxNi43MDcxOTEsMy41MTQyNDk5MyAxNi41MTIsMy4zMTkgTDE1LjgwNCwyLjYxMiBDMTUuNjA4NzUwMSwyLjQxNjgwOTAzIDE1LjI5MjI0OTksMi40MTY4MDkwMyAxNS4wOTcsMi42MTIgTDEzLjc4MSwzLjkzIEwxMy43OCwzLjkzIFogTTE3LjIxOSwxLjE5OCBMMTcuOTI2LDEuOTA1IEMxOC45MDE5NTQ4LDIuODgxMjQ5NjMgMTguOTAxOTU0OCw0LjQ2Mzc1MDM3IDE3LjkyNiw1LjQ0IEw1LjYzNCwxNy43MzMgTDEuNDE0LDE4Ljk1MyBDMS4wNjM2NjE3LDE5LjA1NDAxMiAwLjY4NjExMjg5NCwxOC45NTYzNDA0IDAuNDI4NzExMjksMTguNjk4MTA2NSBDMC4xNzEzMDk2ODYsMTguNDM5ODcyNSAwLjA3NDg1NzQ1MiwxOC4wNjIwMTA0IDAuMTc3LDE3LjcxMiBMMS40MjUsMTMuNDU3IEwxMy42ODUsMS4xOTcgQzE0LjY2MTI0OTYsMC4yMjEwNDUxNTQgMTYuMjQzNzUwNCwwLjIyMTA0NTE1NCAxNy4yMiwxLjE5NyBMMTcuMjE5LDEuMTk4IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=") no-repeat top left !important;
  border: none;
  width: 36px;
  height: 20px;
  cursor: pointer;
}

.settings-page .btn-trush {
  background: url("data:image/svg+xml;base64,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") no-repeat center left !important;
  border: none;
  width: 36px;
  height: 20px;
  cursor: pointer;
}

.settings-page .edit-btn {
  height: 31px;
  width: 101px;
  cursor: pointer;
  border: 1px solid rgba(28, 31, 57, 0.25) !important;

}

.settings-page .update-btn {
  width: 100px;
  height: 31px;
  border: none;
  cursor: pointer;
  background-color: #5E79FF !important;
  color: #FFFFFF;
}

.settings-page .bx-cloud-upload {
  font-size: 37px !important;
  color: #5E79FF;
}

.settings-page .unlock-btn {
  cursor: pointer;
  height: 31px;
  width: 101px;
  border: 1px solid rgba(28, 31, 57, 0.25) !important;
  border-radius: 3px;
  background: none;
  font-size: 13px;
  font-weight: bold;
}

.settings-page .action-btns {
  height: 30px;
  padding: 6px;
  justify-content: flex-end;

}

.settings-page .action-btns button {
  border-radius: 3px;
  font-size: 13px;
  font-weight: bold;
  background: none;
  margin-left: 5px;
  margin-right: 5px;
  cursor: pointer;
}

.settings-page .table-header {
  border: none !important;
  height: 48px;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
}

.settings-page .table-responsive {
  border-radius: 3px;
  background-color: rgba(27, 30, 56, 0.1);
  overflow-x: initial !important;
}

.settings-page .tab-content-table {
  padding-top: 12px;
}

.settings-page .table td {
  border-bottom: 1px solid rgba(27, 30, 56, .25) !important;
}

.settings-page .table td.name, .settings-page .table td.role {
  font-family: "Nunito Sans" !important;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
}

.settings-page .table td.role {
  font-size: 12px;
}

.settings-page .table-header {
  font-size: 13px;
  font-weight: bold;
  border: none !important;
  vertical-align: middle !important;
}

.settings-page .table-body {
  font-size: 12px;
  font-weight: 600;
}

.settings-page .close-active-btn {
  height: 31px;
  width: 152px;
  border: 1px solid rgba(28, 31, 57, 0.25) !important;
  color: #1C1F39;
  border-radius: 3px !important;
  font-family: "Nunito Sans";
  background: none;
  font-weight: bold;
}

.settings-page .delete-user {
  height: 31px;
  width: 101px;
  border: 1px solid #FF5E5E !important;
  border-radius: 3px !important;
  color: #FF5E5E;
  background: none;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 10px;
}

.settings-page .update-password-section {
  margin-top: 15px;
  margin-bottom: 15px;
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
}

.settings-page .detail-section {
  border: 1px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
}

.settings-page .section-header {
  padding: 1rem;
  font-size: 13px;
  font-weight: bold;
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
}

.settings-page .detail-body {
  padding: 1rem;
}

.settings-page .user-photo {
  text-align: center;
}

.settings-page .user-photo img {
  width: 100%;
  border-radius: 3px;
}

.settings-page .user-avatar-section {
  padding-left: 0 !important;
}

.settings-page .user-avatar-section button {
  width: 100%;
  border-radius: 3px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: bold;
  background-color: #FF5E5E;
  margin-top: 10px;
}

.settings-page .user-name {
  margin-top: 6px;
  font-size: 21px;
  font-weight: bold;
}

.settings-page .active-user-text {
  margin-left: 12px;
}

.settings-page .user-detail-section {
  padding: 0 !important;
}

.settings-page .user-detail-section .col-form-label {
  padding-left: 6px !important;
}

.settings-page .user-detail-section .form-text {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}


.settings-page .table td {
  border-bottom: 1px solid rgba(27, 30, 56, .25) !important;
}

.settings-page .table td.name {
  font-size: 12px;
  font-weight: bold;
}

.settings-page .table td.role {
  font-size: 12px;
}

.settings-page .drop-down-text {
  color: #1C1F39;
  font-size: 13px;
  font-weight: 700;
}

.tooltip-inner {
  background-color: white !important;
  color: black !important;
  font-family: "Nunito Sans" !important;
  font-size: 13px !important;
  font-weight: bold !important;

}

.tooltip {
  width: 200px;
  background-color: white !important;
  color: black;
  border: 1px solid #5E79FF;
  border-radius: 3px;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
  position: absolute;
  z-index: 1;
  text-align: center;
  padding: 5px;
  margin-left: -94px;
}


.settings-page .business-details .col-md-5 {
  padding-left: 0;
}


.settings-page .active-icon {
  height: 8px;
  width: 8px;
  background-color: #2DCA73;
  border-radius: 50%;
  position: absolute;
  margin-top: 4px;
}

.settings-page .active-icon.inactive {
  background-color: lightgray;
}

.settings-page .edit-active-icon {
  margin-top: 9px;
}

.settings-page .active-user-text {
  margin-left: 12px;
}

.settings-page .edit-active-icon {
  margin-top: 9px;
}

.settings-page .multiselect__select:before {
  font-size: 23px;
}

.multiselect__option {
  /*   height: 40px;*/
}


.settings-page .text-active {
  top: -3px;
  position: relative;
}
</style>

<style>
/* Utilities */
.d-flex {
  display: flex !important;
}

.flex-row {
  flex-direction: row !important;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-end {
  justify-content: end;
}

.justify-content-center {
  justify-content: center;
}

.items-between {
  align-items: space-between;
}

.items-end {
  align-items: end;
}

.items-center {
  align-items: center;
}

.d-none {
  display: none !important;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/* is-mobile */
/* estimate-edit is-mobile */
.V3 .is-mobile .table th,
.V3 .is-mobile .table td {
  padding: 0.5rem 0.35rem;
}

.V3 .tabs-component.is-mobile,
.V3 .tabs-component.tabs-component-2.is-mobile {
  position: static;
}

.V3 .nav-tabs.nav-tabs-2.is-mobile,
.V3 .tabs-component .tab-header.is-mobile {
  display: flex;
  flex-flow: row nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
}

.V3 .is-mobile select.form-control {
  padding-right: 20px !important;
}

/* end is-mobile */

.whitespace-nowrap {
  white-space: nowrap;
}

</style>

<style>
/* ps-tooltip */

.V3 .b-tooltip {
  z-index: 10001;
}

.V3 .ps-tooltip.tooltip.b-tooltip {
  margin-top: 0;
  border: 0;
  background-color: transparent !important;
}

.V3 .ps-tooltip.tooltip.b-tooltip .tooltip-inner {
  border-radius: 10px 0 10px 10px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 8px 0 rgba(27, 30, 56, 0.25);
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  padding: 10px;
  /* font-weight: 400; */
}

.V3 .ps-tooltip.tooltip.b-tooltip.ps-tooltip-round .tooltip-inner {
  border-radius: 10px;
}

.V3 .ps-tooltip.tooltip.b-tooltip .arrow {
  display: none;
}

.V3 .ps-tooltip--table > * {
  position: relative;
  top: -10px;
  right: 15px;
}

.V3 .ps-tooltip--table[x-placement="top"] > * {
  top: 5px;
  border-radius: 10px 10px 0px 10px !important;
}

</style>


<style>
/* pagination */

.pagination-block .pagination-block-showing input.form-control {
  height: 27px;
  width: 43px;
  margin-left: 5px;
  font-size: 12px;
  color: #1C1F39;
  text-align: center;
}

/* Browse buttons */

.browse-btn-files,
.cancel-btn,
.browse-btn-images,
.estimates-template-btn {
  margin: 5px !important;
}

.pac-logo:after {
  display: none;
}

.estimates-edit-page .icon-action-block .action-button,
.estimates-edit-page .actions--topleft .actions__item,
.estimates-edit-page .gallery-img .gallery-delete,
.cards-edit-page .icon-action-block .action-button,
.cards-edit-page .actions--topleft .actions__item,
.cards-edit-page .gallery-img .gallery-delete {
  background-color: #efefef;
}

/* b-promos */
.mobile-b-promo-block {
  display: none;
}

.desktop-b-promo-block {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.medium-b-promo {
  display: flex;
  margin-left: 15px;
}

.estimare-header-b-promo {
  display: none;
}

.mobile-b-promo-block .leaderboard-b-promo,
.mobile-b-promo-block .leaderboard-b-promo img {
  height: 50px;
  width: 320px;
  object-fit: contain;
}

.medium-rectangle-b-promo,
.medium-rectangle-b-promo img {
  height: 250px;
  width: 300px;
  object-fit: contain;
}

.desktop-b-promo-block .skyscrapper-b-promo,
.desktop-b-promo-block .skyscrapper-b-promo img {
  height: 600px;
  width: 300px;
  object-fit: contain;
}

.estimare-image-gallery-b-promo {
  display: none;
}

.estimare-activity-list-b-promo,
.cards-activity-list-b-promo {
  display: none;
}

.medium-rectangle-b-promo-block {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

@media screen and (max-width: 767px) {
  .mobile-b-promo-block {
    width: 90%;
    background-color: white;
    display: flex;
    justify-content: center;
    margin-bottom: 0;
    position: fixed;
    z-index: 99;
    bottom: 0;
  }
}

@media screen and (max-width: 990px) {
  .desktop-b-promo-block {
    display: none;
  }
}

@media screen and (min-width: 1250px) {
  .estimare-header-b-promo {
    display: flex;
    position: absolute;
    top: 5px;
    left: 520px;
    width: calc(100% - 520px) !important;
  }
}

@media screen and (min-width: 1420px) {
  .estimare-image-gallery-b-promo {
    display: flex;
    position: fixed;
    top: 170px;
    left: 1155px;
  }
}

@media screen and (min-width: 1200px) {
  .estimare-activity-list-b-promo,
  .cards-activity-list-b-promo {
    display: flex;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .medium-rectangle-b-promo-block {
    display: none;
  }
}

.send-to-additional-position-image-wizard .gallery-wrap {
  top: -265px !important;
  left: -15px !important;
  height: 100%;
}

.pin-image-lightbox .gallery-container {
  max-width: 760px !important;
}

@media screen and (min-width: 1420px) {
  .pin-image-lightbox .estimare-image-gallery-b-promo {
    left: 1020px !important;
  }
}

.gallery-wrap {
  height: -webkit-fill-available;
}

.pin-image-lightbox .gallery-ready {
  margin-top: 135px !important;
}

.pin-image-lightbox .gallery-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.pin-image-lightbox .gallery-wrap {
  position: fixed !important;
  top: 0 !important;
  width: 100% !important;
  overflow: scroll !important;
  height: 85vh;
}

.V3 .boards {
  --yellow: #FAFC00;
  --orange: #FF7900;
  --green: #2DCA73;
  --blue: #2EA9FF;
  --grey: rgba(255, 255, 255, 0.5);

  --board-header: var(--yellow);
  --assignee-color: var(--green);
  --rego-color: var(--orange);
  --status-color: var(--yellow);
}

.V3 .boards .table td,
.V3 .boards .table th {
  border-color: transparent;
}

.V3 .boards .background-white {
  background-color: white !important;
  padding: 0px !important;
  color: white !important;
  /*height: 45px;*/
}

.V3 .boards .background-white td {
  background-color: white !important;
  padding: 0px !important;
  color: white !important;
  height: 45px;
}

.V3 .boards .background-white-td {
  background-color: white !important;
  padding: 0px !important;
  color: white !important;
  height: 45px;
}

.border-image img:hover {
  border: 2px solid red;
  border-radius: 4px;
}

.V3 .boards .tab-content-table table .cards-table-number {
  width: 5%;
  word-wrap: break-word;
  font-weight: bold;
}

.V3 .boards .tab-content-table table .cards-table-vehicle-owner {
  width: 5%;
  font-weight: bold;
}

.V3 .boards .tab-content-table table .cards-table-rego {
  width: 6%;
  color: var(--rego-color);
}

.V3 .boards .tab-content-table table .cards-table-make {
  width: 6%;
}

.V3 .boards .tab-content-table table .cards-table-model {
  width: 10%;
}

.V3 .boards .tab-content-table table .cards-table-colour {
  width: 10%;
}

.V3 .boards .tab-content-table table .cards-table-insurer {
  width: 60px;
}

.V3 .boards .tab-content-table table .cards-table-created-on {
  width: 100px;
}

.V3 .boards .tab-content-table table .cards-table-assigned-to {
  width: 12%;
  color: var(--assignee-color);
}

.col-xs-12 {
  width: 100% !important;
}

.V3 .assessors-page .assessors-edit-btn {
  width: 100px;
}

.V3 .boards .tab-content-table table .cards-table-notifications {
  width: 120px;
}

.V3 .boards .tab-content-table table .cards-table-status {
  width: 8%;
  color: var(--status-color);
}

.V3 .boards .tab-content-table table .cards-table-image {
  padding: 7px 0;
  width: 50px !important;
  color: var(--status-color);
}

.V3 .boards .vehicle-image-container {
  display: grid;
  grid-template-columns: repeat(1, 80px);
  gap: 10px;
  justify-content: center;
}

.V3 .boards .vehicle-image {
  position: relative;
  padding-bottom: 100%;
  border-radius: 4px;
  overflow: hidden;
}

.V3 .boards .vehicle-image img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
}

.V3 .boards .tabs-component .tab-header {
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 23.5px;
}

.V3 .boards .dropdown-options .btn {
  border-color: rgba(29, 32, 58, 0.25);
  height: 39px;
}

.V3 .table.b-table > thead > tr {
  padding-bottom: 50px;
}

.header-display-name {
  position: absolute;
  right: 15px;
  top: 25px;
}

@media screen and (max-width: 500px) {
  .header-display-name {
    display: none;
  }
}

/**  Table column widths to apply for desktop and tablet  **/

.V3 .cards-page .tab-content-table table .cards-table-number,
.V3 .estimates-page .tab-content-table table .estimates-table-number {
  width: 90px;
  font-weight: bold;
}

.V3 .cards-page .tab-content-table table .cards-table-vehicle-owner,
.V3 .estimates-page .tab-content-table table .estimates-table-vehicle-owner {
  width: 125px;
  font-weight: bold;
}

.V3 .cards-page .tab-content-table table .cards-table-rego,
.V3 .estimates-page .tab-content-table table .estimates-table-rego {
  width: 75px;
}

.V3 .cards-page .tab-content-table table .cards-table-make,
.V3 .estimates-page .tab-content-table table .make {
  width: 75px;
}

.V3 .cards-page .tab-content-table table .cards-table-model,
.V3 .estimates-page .tab-content-table table .model {
  width: 110px;
}

.V3 .cards-page .tab-content-table table .cards-table-colour,
.V3 .estimates-page .tab-content-table table .amount {
  width: 115px;
}

.V3 .cards-page .tab-content-table table .cards-table-insurer,
.V3 .estimates-page .tab-content-table table .insurer {
  width: 60px;
}

.V3 .cards-page .tab-content-table table .cards-table-created-on,
.V3 .estimates-page .tab-content-table table .created-on {
  width: 100px;
}

.V3 .cards-page .tab-content-table table .cards-table-assigned-to,
.V3 .estimates-page .tab-content-table table .assigned {
  width: 140px;
}

.V3 .cards-page .tab-content-table table .cards-table-notifications,
.V3 .estimates-page .tab-content-table table .notification {
  width: 120px;
}

.V3 .cards-page .tab-content-table table .cards-table-status,
.V3 .estimates-page .tab-content-table table .status {
  width: 160px;
}

.options-menu-height {
  overflow: auto;
}

.options-menu-height::-webkit-scrollbar-track {
  background-color: white;
}

.my-custom-toast-class {
  background: linear-gradient(135deg, #7267E7 0%, #6259EF 49.12%, #4E45EE 100%);
  font-size: 16px;
}

.my-custom-toast-class button {
  color: #d3d3d3;
  font-size: 14px;
}

.my-custom-toast-class button:hover,
.my-custom-toast-class .close-toast:hover {
  color: white;
}

.my-custom-toast-class .close-toast {
  font-size: 20px;
  color: #d3d3d3;
}

.my-custom-toast-class .toast-text {
  margin-top: 10px;
  font-size: 13px;
}

.planner-page .theme--light.v-calendar-daily .v-calendar-daily__day-interval {
  border-top: 1px solid rgba(28, 31, 57, 0.25);
}

.planner-page .theme--light.v-calendar-daily .v-calendar-daily_head-day {
  border-right: 1px solid rgba(28, 31, 57, 0.25) !important;
  border-bottom: 1px solid rgba(28, 31, 57, 0.25) !important;
}

.planner-page .theme--light.v-calendar-daily .v-calendar-daily__day {
  border-right: 1px solid rgba(28, 31, 57, 0.25) !important;
  border-bottom: 1px solid rgba(28, 31, 57, 0.25) !important;
}

.planner-page .theme--light.v-calendar-daily .v-calendar-daily__intervals-head {
  border-right: 1px solid rgba(28, 31, 57, 0.25) !important;
}

.planner-page .theme--light.v-calendar-daily .v-calendar-daily__intervals-body {
  border-right: 1px solid rgba(28, 31, 57, 0.25) !important;
}

.planner-page .theme--light.v-calendar-daily {
  border-left: 1px solid rgba(28, 31, 57, 0.25) !important;
  border-top: 1px solid rgba(28, 31, 57, 0.25) !important;
}

.planner-page .theme--light.v-calendar-weekly {
  border-left: 1px solid rgba(28, 31, 57, 0.25) !important;
  border-top: 1px solid rgba(28, 31, 57, 0.25) !important;
}

.planner-page .theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border-right: 1px solid rgba(28, 31, 57, 0.25) !important;
  border-bottom: 1px solid rgba(28, 31, 57, 0.25) !important;
}

.planner-page .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
  border-right: 1px solid rgba(28, 31, 57, 0.25) !important;
}

.V3 .disabled-cards-edit-is-user {
  pointer-events: none;
}

.V3 .disabled-cards-edit-is-user span.text-grey i {
  color: #aaaaaa !important;
}
</style>
<!--Insurer Card Colour-->
<style>
.insurer-card-color .insurer-card-color-id-1 {
  font-weight: 700;
  color: #f85d09 !important;
  background-color: #f9e3d4 !important;
}

.insurer-card-color .insurer-card-color-id-2 {
  font-weight: 700;
  color: #051583 !important;
  background-color: #cbcee4 !important;
}

.insurer-card-color .insurer-card-color-id-3 {
  font-weight: 700;
  color: #35bad7 !important;
  background-color: #d5eff5 !important;
}

.insurer-card-color .insurer-card-color-id-4 {
  font-weight: 700;
  color: #f8d040 !important;
  background-color: #fcf4d7 !important;
}

.insurer-card-color .insurer-card-color-id-5 {
  font-weight: 700;
  color: #88cd1b !important;
  background-color: #e5f3cf !important;
}

.insurer-card-color .insurer-card-color-id-6 {
  font-weight: 700;
  color: #1b5712 !important;
  background-color: #cfdbce !important;
}

.insurer-card-color .insurer-card-color-id-7 {
  font-weight: 700;
  color: #886ecc !important;
  background-color: #e5e0f3 !important;
}

.insurer-card-color .insurer-card-color-id-8 {
  font-weight: 700;
  color: #e85076 !important;
  background-color: #f8dae2 !important;
}

.V3 .cursor-not-allowed {
  cursor: not-allowed !important;
}
</style>
